// Share the loaded theme asset's CDN directory; keep Inbox positioning isolated.
if (document.currentScript && document.currentScript.src) {
  var chatSafeAreaScript = document.createElement('script');
  chatSafeAreaScript.src = new URL('vmcm-chat-safe-area.js', document.currentScript.src).href;
  document.head.appendChild(chatSafeAreaScript);
}

window.VelvenDeferredVideos = window.VelvenDeferredVideos || {
  init: function (root) {
    Array.prototype.slice.call(root.querySelectorAll("video[data-vmcm-deferred-video]")).forEach(function (video) {
      var loaded = false;
      function loadVideo() {
        if (loaded) return;
        loaded = true;
        Array.prototype.slice.call(video.querySelectorAll("source[data-src]")).forEach(function (source) {
          source.src = source.getAttribute("data-src");
          source.removeAttribute("data-src");
        });
        video.load();
      }
      video._vmcmLoadDeferred = loadVideo;
      if (!("IntersectionObserver" in window)) {
        loadVideo();
        return;
      }
      var preloadIO = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadVideo();
          observer.unobserve(video);
        });
      }, { root: root, rootMargin: "0px", threshold: 0 });
      preloadIO.observe(video);
    });
  }
};

window.VelvenExpressCheckout = window.VelvenExpressCheckout || {
  sync: function (elements, selection) {
    if (!elements || !elements.expressForm) return;
    var ready = !!(selection.variantId && selection.available);
    elements.expressForm.hidden = !ready || !!selection.preorder || !selection.cart || (selection.cart.items || []).some(function (item) {
      return !!(item.properties && item.properties[(window.VELVEN_PREORDER && window.VELVEN_PREORDER.key) || "Preorder"]);
    });
    if (elements.expressVariant) elements.expressVariant.value = selection.variantId || "";
    if (elements.expressQuantity) {
      elements.expressQuantity.value = ready && selection.isRoll ? Math.max(1, Number(selection.quantity) || 1) : 1;
    }
  }
};

/* ============================================================================
   VELVEN — global scroll-hint dismissal
   The chrome hint renders on every immersive route, including ones that carry no
   .vmcm-feed (policy pages), so the is-scrolled flag lives outside the feed
   engine. One capture listener sees both document scrolling and the feed's own
   scroller; unrelated nested scrollers (sheets, peeks) are ignored.
   ========================================================================== */
(function () {
  "use strict";

  var scrolled = false;

  function documentScrollTop() {
    if (window.scrollY) return window.scrollY;
    return document.scrollingElement ? document.scrollingElement.scrollTop : 0;
  }

  function isFeedTarget(target) {
    return !!(target && target.classList && target.classList.contains("vmcm-feed"));
  }

  function isDocumentTarget(target) {
    return target === document
      || target === window
      || target === document.scrollingElement
      || target === document.documentElement
      || target === document.body;
  }

  function scrollDepth(event) {
    if (!event) {
      var feed = document.querySelector(".vmcm-feed");
      return Math.max(documentScrollTop(), feed ? feed.scrollTop : 0);
    }
    var target = event.target;
    if (isFeedTarget(target)) return target.scrollTop;
    if (isDocumentTarget(target)) return documentScrollTop();
    return 0;
  }

  function markScrolled(event) {
    if (scrolled) return;
    if (scrollDepth(event) <= 40) return;
    scrolled = true;
    document.body.classList.add("is-scrolled");
  }

  window.addEventListener("scroll", markScrolled, { passive: true, capture: true });
  markScrolled();
})();

/* ============================================================================
   VELVEN — MCM immersive feed engine (vanilla, no framework)
   1. scroll-snap helpers + lazy   2. live NN/NN index
   3. global comfort-ease pinch     4. adaptive difference/solid chrome
   5. drawer centre detection       6. selection sheet + express add
   ========================================================================== */
(function () {
  "use strict";

  var feed = document.querySelector(".vmcm-feed");
  if (!feed) return;

  var root = document.documentElement;
  var body = document.body;
  var panels = Array.prototype.slice.call(feed.querySelectorAll(".vmcm-panel"));
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var verticalMagnetics = false;

  /* Shared scroll-glide easing — easeOutQuart: a confident start with a long,
     calm settle. Every JS scroll tween (panel snap, touch swipe, touchpad /
     keyboard, the inspiration wall) runs through this, so the whole site
     decelerates with one smooth, slowed feel rather than the browser's abrupt
     native scroll-snap timing. */
  function easeGlide(p) { return 1 - Math.pow(1 - p, 4); }

  /* Catalogue keyed by handle (emitted by snippets/vmcm-materials-data.liquid) */
  var MATERIALS = window.VELVEN_MATERIALS || [];
  var byHandle = {};
  MATERIALS.forEach(function (m) { byHandle[m.handle] = m; });

  var routes = (window.theme && window.theme.routes) || {};
  var ROOT = routes.root_url || "/";
  var ADD = routes.cart_add_url || ROOT.replace(/\/$/, "") + "/cart/add.js";
  var CART = routes.cart_url || ROOT.replace(/\/$/, "") + "/cart";

  function standardCartAdd(items, target, context, request) {
    if (window.VelvenCartEvents) return window.VelvenCartEvents.add({ target: target, context: context, items: items }, request);
    var state = window.VelvenSampleProgress;
    if (state) state.invalidate();
    return request().then(function (result) {
      if (state) state.invalidate();
      return result;
    }, function (error) {
      if (state) state.invalidate();
      throw error;
    });
  }

  function money(cents) {
    if (cents == null) return "";
    return "$" + (cents / 100).toFixed(2);
  }

  /* --------------------------------------------------------------------------
     2. Live NN/NN index — IntersectionObserver, centre slab
     COUNT_RULE selects which panels count toward the set. Default: all panels.
     ------------------------------------------------------------------------ */
  var COUNT_RULE = function (panel) { return panel.hasAttribute("data-feed-role"); };
  var setPanels = panels.filter(COUNT_RULE);
  var total = setPanels.length;

  var idxEl = document.querySelector("[data-feed-index]");
  var totalEl = document.querySelector("[data-feed-total]");
  var liveEl = document.querySelector("[data-feed-live]");
  if (totalEl) totalEl.textContent = pad(total);

  function pad(n) { return String(n).padStart(2, "0"); }

  var activePanel = null;
  var liveTimer = null;

  var indexIO = new IntersectionObserver(function (entries) {
    var best = null;
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (!e.isIntersecting) continue;
      if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
    }
    if (!best) return;
    setActivePanel(best.target);
  }, { root: feed, rootMargin: "-45% 0px -45% 0px", threshold: 0 });

  panels.forEach(function (p) { indexIO.observe(p); });

  function setActivePanel(panel) {
    if (panel === activePanel) return;
    activePanel = panel;

    if (COUNT_RULE(panel) && idxEl) {
      var n = setPanels.indexOf(panel) + 1;
      idxEl.textContent = pad(n);
      if (liveEl) {
        clearTimeout(liveTimer);
        liveTimer = setTimeout(function () {
          var label = panel.getAttribute("data-feed-label") || panel.getAttribute("data-feed-role") || "panel";
          liveEl.textContent = label + ", " + n + " of " + total;
        }, 260);
      }
    }
    applyChrome(panel);
    var ph = panel.querySelector("[data-cols-hint]");
    if (ph) maybeRevealHint(ph);
  }

  /* --------------------------------------------------------------------------
     4. Adaptive chrome — difference over clear hues, solid pill over mid-tones
     ------------------------------------------------------------------------ */
  function hexLum(hex) {
    if (!hex) return null;
    var h = hex.replace("#", "");
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var r = parseInt(h.substr(0, 2), 16) / 255;
    var g = parseInt(h.substr(2, 2), 16) / 255;
    var b = parseInt(h.substr(4, 2), 16) / 255;
    var lin = function (c) { return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
    return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  }

  function applyChrome(panel) {
    var mode = panel.getAttribute("data-chrome");      // optional override
    var bg = panel.getAttribute("data-bg");
    var solid = false, lightText = true;

    if (mode === "solid-light") { solid = true; lightText = true; }
    else if (mode === "solid-dark") { solid = true; lightText = false; }
    else if (mode === "difference") { solid = false; }
    else if (bg) {
      var lum = hexLum(bg);
      if (lum != null && lum > 0.16 && lum < 0.74) { solid = true; lightText = lum < 0.5; }
    }

    // The chrome bar always needs a known ink + ground (its scrim is tinted to
    // the panel beneath), so derive them from the panel colour even when the
    // marks are not "solid": dark grounds take light marks and vice versa.
    if (!solid && bg) {
      var bgLum = hexLum(bg);
      if (bgLum != null) lightText = bgLum < 0.5;
    }
    root.style.setProperty("--chrome-ink", lightText ? "#ECE5D6" : "#16140E");
    root.style.setProperty("--chrome-bg", bg && !solid ? bg : (lightText ? "#16140E" : "#ECE5D6"));
    body.classList.toggle("chrome-solid", solid);

    // Hide the centred logo only over FULL-BLEED photo scenes (a room shot) where
    // it sits on top of busy imagery; it stays over framed material plates (which
    // reserve clear colour ground up top) and clean colour planes, and over any
    // panel that opts to keep it (data-keep-logo). This keeps the wordmark present
    // across the home feed instead of vanishing over every finish panel.
    body.classList.toggle("vmcm-logo-out", panel.classList.contains("vmcm-panel--photo") && !panel.classList.contains("vmcm-panel--plate") && !panel.hasAttribute("data-keep-logo"));
  }

  /* --------------------------------------------------------------------------
     3. Global comfort-ease pinch (the tricky one)
     Native pinch is suppressed on the feed (touch-action: pan-y + JS).
     Pinch-out eases the whole feed; pinch-in restores. Persists per session.
     ------------------------------------------------------------------------ */
  var KEY = "velven:comfortEase";
  var EASED = 0.84, FULL = 1, TH = 0.06;
  var eased = sessionStorage.getItem(KEY) === "1";
  var usingGesture = false;

  /* --------------------------------------------------------------------------
     Pinch-resizable grids — ANY [data-pinch-grid] (the shop grid, the sample
     swatches) steps through column levels with a FLIP morph. A pinch maps to the
     grid in the active panel; with no panels (the shop page) it maps to the sole
     grid. Where there is no grid to resize, pinch falls back to comfort-ease.
     Per-grid config via data-cols-min / -max / -mobile / -desktop / -pinch-key.
     ------------------------------------------------------------------------ */
  var FLIP_DUR = 640, FLIP_EASE = "cubic-bezier(0.22, 0.61, 0.36, 1)";
  var WIDE = window.matchMedia("(min-width: 1024px)").matches;
  var pinchGrids = Array.prototype.slice.call(feed.querySelectorAll("[data-pinch-grid]"));

  function gridConf(g) {
    var min = parseInt(g.getAttribute("data-cols-min"), 10) || 1;
    var max = parseInt(g.getAttribute("data-cols-max"), 10) || 3;
    var def = parseInt(WIDE ? g.getAttribute("data-cols-desktop") : g.getAttribute("data-cols-mobile"), 10);
    if (!def) def = WIDE ? 3 : 2;
    return { min: min, max: max, def: def, key: g.getAttribute("data-pinch-key") || "grid" };
  }
  function setGridCols(g, n) {
    g.classList.remove("is-cols-1", "is-cols-2", "is-cols-3", "is-cols-4");
    g.classList.add("is-cols-" + n);
    g._cols = n;
  }
  /* FLIP: snapshot each tile's box, swap columns, then animate from old box to
     new so the resize glides instead of jumping. */
  function applyGridCols(g, n, animate) {
    var c = gridConf(g);
    n = Math.max(c.min, Math.min(c.max, n));
    if (n === g._cols && g.classList.contains("is-cols-" + n)) { dismissGridHint(g); return; }

    var prev = g._cols;
    var snap = g.hasAttribute("data-pinch-snap");
    var prevScrollTop = feed.scrollTop, prevMax = feed.scrollHeight - feed.clientHeight;

    var tiles = (animate && !reduceMotion) ? Array.prototype.slice.call(g.children) : [];
    var firsts = tiles.map(function (t) { return t.getBoundingClientRect(); });

    setGridCols(g, n);
    try { sessionStorage.setItem("velven:cols:" + c.key, String(n)); } catch (e) {}
    if (liveEl) liveEl.textContent = n + " per row";
    dismissGridHint(g);

    // Snap-immersive grids (the inspiration wall): keep the scroll sensible across
    // the immersive <-> wall morph. Zoom IN to immersive -> map the wall position
    // onto the room feed, aligned to a clean panel. Zoom OUT of immersive -> show
    // the wall from the top. Set BEFORE measuring the FLIP "last" rects so the morph
    // lands on the final scroll (no post-animation jump). Gallery<->gallery keeps place.
    if (snap) {
      var h = feed.clientHeight || 1;
      if (n === c.min) {
        var frac = prevMax > 0 ? prevScrollTop / prevMax : 0;
        var newMax = feed.scrollHeight - feed.clientHeight;
        feed.scrollTop = Math.round((frac * newMax) / h) * h;
      } else if (prev === c.min) {
        feed.scrollTop = 0;
      }
    }

    if (!tiles.length) return;
    tiles.forEach(function (t, i) {
      var a = firsts[i], b = t.getBoundingClientRect();
      var dx = a.left - b.left, dy = a.top - b.top;
      var sx = b.width ? a.width / b.width : 1, sy = b.height ? a.height / b.height : 1;
      if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5 && Math.abs(sx - 1) < 0.01 && Math.abs(sy - 1) < 0.01) return;
      t.style.transformOrigin = "top left";
      t.style.transition = "none";
      t.style.willChange = "transform";
      t.style.transform = "translate(" + dx + "px," + dy + "px) scale(" + sx + "," + sy + ")";
    });
    void feed.offsetWidth;                       // flush the inverted state, then play
    tiles.forEach(function (t) {
      t.style.transition = "transform " + FLIP_DUR + "ms " + FLIP_EASE;
      t.style.transform = "";
    });
    clearTimeout(g._flipTimer);
    g._flipTimer = setTimeout(function () {
      tiles.forEach(function (t) {
        t.style.transition = ""; t.style.transform = ""; t.style.transformOrigin = ""; t.style.willChange = "";
      });
    }, FLIP_DUR + 60);
  }
  function stepGrid(g, dir) { try { localStorage.setItem("velven:pinched:" + gridConf(g).key, "1"); } catch (e) {} applyGridCols(g, (g._cols || gridConf(g).def) + dir, true); }

  pinchGrids.forEach(function (g) {
    var c = gridConf(g);
    var saved = parseInt(sessionStorage.getItem("velven:cols:" + c.key), 10);
    setGridCols(g, (saved >= c.min && saved <= c.max) ? saved : c.def);
  });

  // the grid a pinch should resize right now (active panel's grid, or the sole grid)
  function pinchTarget() {
    if (activePanel) { var g = activePanel.querySelector("[data-pinch-grid]"); if (g) return g; }
    if (!panels.length && pinchGrids.length === 1) return pinchGrids[0];
    return null;
  }

  /* The brief "Pinch to resize" cue — once per session per hint, revealed on the
     panel where the gesture applies. */
  function maybeRevealHint(hint) {
    if (!hint || hint._shown) return;
    var key = hint.getAttribute("data-hint-key") || "grid";
    // Show the pinch cue on every visit UNTIL the shopper has actually pinched
    // once (persisted), rather than once-per-session — so it reliably teaches the
    // gesture and then stays out of the way for good once they've used it.
    try { if (localStorage.getItem("velven:pinched:" + key) === "1") return; } catch (e) {}
    hint._shown = true;
    requestAnimationFrame(function () { hint.classList.add("is-in"); });
    hint._timer = setTimeout(function () { hint.classList.add("is-out"); }, 12000);
  }
  function dismissGridHint(g) {
    var scope = g.closest(".vmcm-panel") || g.closest(".vmcm-shop") || document;
    var hint = scope.querySelector("[data-cols-hint]");
    if (hint) { if (hint._timer) clearTimeout(hint._timer); hint.classList.add("is-out"); }
  }
  // reveal any hint already on screen (the shop page grid has no enclosing panel)
  Array.prototype.slice.call(document.querySelectorAll("[data-cols-hint]")).forEach(function (hint) {
    if (!hint.closest(".vmcm-panel")) maybeRevealHint(hint);
  });

  initToneFilter();
  initInspOffer();
  initScrollCue();
  initToolUpsell();
  window.VelvenDeferredVideos.init(feed);
  initCarousels();
  initCustomerShowcases();
  initCompareButtons();
  initCommercialStories();
  applyEase(eased, true);

  /* Shared carousel — the customer showcase and the commercial case studies.
     Native horizontal scroll-snap is the gesture layer, so touch swipe, trackpad
     and keyboard scrolling all work without script. This adds the arrows, one dot
     per reachable scroll position, arrow/Home/End keys and mouse drag. When every
     slide already fits the track the controls stay hidden: no dead buttons. */
  function initCarousels() {
    Array.prototype.slice.call(feed.querySelectorAll("[data-vmcm-carousel]")).forEach(function (carousel) {
      var track = carousel.querySelector("[data-vmcm-carousel-track]");
      var slides = Array.prototype.slice.call(carousel.querySelectorAll("[data-vmcm-carousel-slide]"));
      var controls = carousel.querySelector("[data-vmcm-carousel-controls]");
      var previous = carousel.querySelector("[data-vmcm-carousel-prev]");
      var next = carousel.querySelector("[data-vmcm-carousel-next]");
      var dotsHost = carousel.querySelector("[data-vmcm-carousel-dots]");
      var status = carousel.querySelector("[data-vmcm-carousel-status]");
      if (!track || !slides.length) return;

      var positions = [];
      var dots = [];
      var activeIndex = -1;
      var scrollFrame = 0;

      function slideLeft(slide) {
        var paddingLeft = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
        return track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left - paddingLeft;
      }
      function nearestIndex() {
        var nearest = 0;
        var nearestDistance = Infinity;
        positions.forEach(function (position, index) {
          var distance = Math.abs(position.left - track.scrollLeft);
          if (distance < nearestDistance) { nearestDistance = distance; nearest = index; }
        });
        return nearest;
      }
      function update(announce) {
        var index = nearestIndex();
        if (previous) previous.disabled = index <= 0;
        if (next) next.disabled = index >= positions.length - 1;
        if (index === activeIndex) return;
        activeIndex = index;
        dots.forEach(function (dot, dotIndex) {
          if (dotIndex === index) dot.setAttribute("aria-current", "true");
          else dot.removeAttribute("aria-current");
        });
        if (status && announce && positions[index]) {
          status.textContent = "Showing " + (positions[index].slide + 1) + " of " + slides.length;
        }
      }
      function goTo(index) {
        if (!positions.length) return;
        var target = positions[Math.max(0, Math.min(positions.length - 1, index))];
        track.scrollTo({ left: target.left, behavior: reduceMotion ? "auto" : "smooth" });
      }
      function measure() {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        positions = [];
        slides.forEach(function (slide, index) {
          var left = Math.max(0, Math.min(maxScroll, Math.round(slideLeft(slide))));
          if (!positions.length || left - positions[positions.length - 1].left > 2) positions.push({ left: left, slide: index });
        });
        var scrollable = maxScroll > 2 && positions.length > 1;
        if (controls) controls.hidden = !scrollable;
        carousel.classList.toggle("is-static", !scrollable);
        if (dotsHost && dots.length !== positions.length) {
          dotsHost.textContent = "";
          dots = positions.map(function (position, index) {
            var dot = document.createElement("button");
            dot.type = "button";
            dot.className = "vmcm-carousel__dot";
            dot.setAttribute("aria-label", "Go to " + (index + 1) + " of " + positions.length);
            dot.addEventListener("click", function () { goTo(index); });
            dotsHost.appendChild(dot);
            return dot;
          });
        }
        activeIndex = -1;
        update(false);
      }

      if (previous) previous.addEventListener("click", function () { goTo(nearestIndex() - 1); });
      if (next) next.addEventListener("click", function () { goTo(nearestIndex() + 1); });
      track.addEventListener("scroll", function () {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(function () { scrollFrame = 0; update(true); });
      }, { passive: true });
      track.addEventListener("keydown", function (event) {
        var index = nearestIndex();
        if (event.key === "ArrowRight") index += 1;
        else if (event.key === "ArrowLeft") index -= 1;
        else if (event.key === "Home") index = 0;
        else if (event.key === "End") index = positions.length - 1;
        else return;
        event.preventDefault();
        goTo(index);
      });

      /* A desktop mouse can grab and drag the track. The pointer is only captured
         once it has really moved, so a plain click still reaches the before/after
         buttons and links inside a slide; the click that ends a drag is swallowed. */
      var dragState = null;
      var suppressClick = false;
      var settleTimer = 0;
      track.addEventListener("pointerdown", function (event) {
        if (event.pointerType !== "mouse" || event.button !== 0) return;
        dragState = { id: event.pointerId, startX: event.clientX, scrollStart: track.scrollLeft, dragging: false };
      });
      track.addEventListener("pointermove", function (event) {
        if (!dragState || event.pointerId !== dragState.id) return;
        var deltaX = event.clientX - dragState.startX;
        if (!dragState.dragging) {
          if (Math.abs(deltaX) < 6) return;
          dragState.dragging = true;
          if (settleTimer) window.clearTimeout(settleTimer);
          try { track.setPointerCapture(event.pointerId); } catch (error) {}
          track.classList.add("is-dragging");
        }
        track.scrollLeft = dragState.scrollStart - deltaX;
      });
      function endDrag(event) {
        if (!dragState || event.pointerId !== dragState.id) return;
        var wasDragging = dragState.dragging;
        var travelled = track.scrollLeft - dragState.scrollStart;
        dragState = null;
        if (!wasDragging) return;
        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 0);
        /* Glide to the slide the drag was heading for, then hand back to scroll-snap. */
        var index = nearestIndex();
        if (positions[index] && Math.abs(travelled) > 40) {
          if (travelled > 0 && positions[index].left < track.scrollLeft) index += 1;
          else if (travelled < 0 && positions[index].left > track.scrollLeft) index -= 1;
        }
        goTo(index);
        settleTimer = window.setTimeout(function () { track.classList.remove("is-dragging"); }, reduceMotion ? 0 : 450);
      }
      track.addEventListener("pointerup", endDrag);
      track.addEventListener("pointercancel", endDrag);
      track.addEventListener("click", function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
      if (window.matchMedia("(pointer: fine)").matches) track.classList.add("is-fine");

      if ("ResizeObserver" in window) new ResizeObserver(measure).observe(track);
      else window.addEventListener("resize", measure);
      measure();
    });
  }

  /* Customer showcase — native horizontal scrolling remains the touch and
     keyboard foundation. A before/after slide rests on the AFTER; a click, tap,
     Enter or Space on the button wipes the before view in, and again wipes it
     out. Nothing flips on its own, so the resting view is always the result. */
  function initCompareButtons() {
    Array.prototype.slice.call(feed.querySelectorAll("[data-showcase-compare]")).forEach(function (compare) {
      var showBeforeLabel = compare.getAttribute("aria-label") || "Show the before view";
      var showAfterLabel = showBeforeLabel.replace(" before ", " after ");
      function setCompareState(revealBefore) {
        compare.classList.toggle("is-before", revealBefore);
        compare.setAttribute("aria-pressed", revealBefore ? "true" : "false");
        compare.setAttribute("aria-label", revealBefore ? showAfterLabel : showBeforeLabel);
        var hint = compare.querySelector("[data-showcase-compare-hint]");
        if (hint) hint.textContent = revealBefore ? "Tap to see after" : "Tap to see before";
      }
      compare.addEventListener("click", function () {
        setCompareState(!compare.classList.contains("is-before"));
      });
    });
  }

  function initCustomerShowcases() {
    Array.prototype.slice.call(feed.querySelectorAll("[data-customer-showcase]")).forEach(function (showcase) {
      Array.prototype.slice.call(showcase.querySelectorAll("[data-showcase-loop]")).forEach(function (loopVideo) {
        // Autoplay on repeat. Muted + inline is the only autoplay phones allow, and
        // the muted state has to be set programmatically because the attribute alone
        // is not honoured after the deferred source swap. Playback (re)starts whenever
        // the slide is in view, and the first tap or key press anywhere retries it for
        // phones that refuse muted autoplay outright (iOS Low Power Mode, data saver).
        loopVideo.muted = true;
        loopVideo.defaultMuted = true;
        loopVideo.loop = true;
        loopVideo.setAttribute("autoplay", "");
        loopVideo.setAttribute("playsinline", "");
        function isLoopActive() { return loopVideo.getAttribute("data-showcase-loop-active") !== "false"; }
        function tryPlayLoop() {
          loopVideo.muted = true;
          if (loopVideo._vmcmLoadDeferred) loopVideo._vmcmLoadDeferred();
          var playAttempt = loopVideo.play();
          if (playAttempt && playAttempt.catch) playAttempt.catch(function () {});
        }
        function retryOnGesture() {
          if (!loopVideo.paused || document.hidden || !isLoopActive()) return;
          tryPlayLoop();
        }
        ["touchend", "pointerup", "keydown"].forEach(function (type) {
          document.addEventListener(type, retryOnGesture, { passive: true });
        });
        if ("IntersectionObserver" in window) {
          var loopIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var active = entry.isIntersecting && entry.intersectionRatio >= 0.5;
              loopVideo.setAttribute("data-showcase-loop-active", active ? "true" : "false");
              if (active && !document.hidden) tryPlayLoop();
              else loopVideo.pause();
            });
          }, { root: feed, threshold: [0, 0.5] });
          loopIO.observe(loopVideo);
        } else {
          tryPlayLoop();
        }
        document.addEventListener("visibilitychange", function () {
          if (document.hidden) loopVideo.pause();
          else if (isLoopActive()) tryPlayLoop();
        });
      });
    });
  }

  /* Commercial case study — the gallery itself is a shared carousel (see
     initCarousels); here the reels only play while they are actually visible. */
  function initCommercialStories() {
    Array.prototype.slice.call(feed.querySelectorAll("[data-commercial-story]")).forEach(function (story) {
      Array.prototype.slice.call(story.querySelectorAll("[data-commercial-loop]")).forEach(function (video) {
        // One slide (the fit-out walkthrough) carries its soundtrack; every other
        // reel stays silent. Browsers refuse unmuted autoplay, so the sound slide
        // asks for it, falls back to a silent loop when it is refused, and always
        // shows a sound button so there is a one-tap way to hear it either way.
        var wantsSound = video.hasAttribute("data-commercial-sound");
        var soundButton = wantsSound ? video.parentNode.querySelector("[data-vmcm-sound-toggle]") : null;
        var soundLabel = soundButton ? soundButton.querySelector("[data-vmcm-sound-label]") : null;
        var mutedByShopper = false;

        function syncSoundButton() {
          if (!soundButton) return;
          soundButton.hidden = false;
          soundButton.setAttribute("data-muted", video.muted ? "true" : "false");
          soundButton.setAttribute("aria-pressed", video.muted ? "false" : "true");
          soundButton.setAttribute("aria-label", video.muted ? "Turn sound on" : "Turn sound off");
          if (soundLabel) soundLabel.textContent = video.muted ? "Tap for sound" : "Sound on";
        }

        function play() {
          if (video._vmcmLoadDeferred) video._vmcmLoadDeferred();
          var playAttempt = video.play();
          if (!playAttempt || !playAttempt.catch) return;
          playAttempt.catch(function () {
            if (!wantsSound || video.muted) return;
            video.muted = true;
            var silentAttempt = video.play();
            if (silentAttempt && silentAttempt.catch) silentAttempt.catch(function () {});
            syncSoundButton();
          });
        }

        if (soundButton) {
          video.muted = false;
          soundButton.addEventListener("click", function () {
            mutedByShopper = !video.muted;
            video.muted = !video.muted;
            if (!video.muted) play();
            syncSoundButton();
          });
          video.addEventListener("volumechange", syncSoundButton);
          syncSoundButton();
          // The autoplay block is lifted by any gesture, so the first one turns the
          // sound on — but only while the slide is actually on screen, and never
          // after the shopper has muted it themselves.
          var unmuteOnGesture = function () {
            if (mutedByShopper || !video.muted) return;
            if (video.getAttribute("data-commercial-loop-active") !== "true") return;
            video.muted = false;
            var soundAttempt = video.play();
            if (soundAttempt && soundAttempt.catch) {
              soundAttempt.catch(function () {
                video.muted = true;
                syncSoundButton();
              });
            }
            syncSoundButton();
          };
          ["pointerup", "touchend", "keydown"].forEach(function (type) {
            document.addEventListener(type, unmuteOnGesture, { passive: true });
          });
        }

        if (reduceMotion || !("IntersectionObserver" in window)) {
          video.removeAttribute("autoplay");
          video.pause();
          return;
        }
        var videoIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var active = entry.isIntersecting && entry.intersectionRatio >= 0.55;
            video.setAttribute("data-commercial-loop-active", active ? "true" : "false");
            if (active && !document.hidden) play();
            else video.pause();
          });
        }, { threshold: [0, 0.55] });
        videoIO.observe(video);
        document.addEventListener("visibilitychange", function () {
          if (document.hidden) video.pause();
          else if (video.getAttribute("data-commercial-loop-active") === "true") play();
        });
      });
    });
  }

  /* Tone filter — the minimal pill row (All / Light / Mid / Dark) on the shop-all
     and sample grids. Mirrors the room-filter contract: [data-tone-filter] holds the
     chips ([data-filter]); the grid it names in data-tone-grid holds tiles tagged
     [data-tone]. Untagged tiles have no [data-tone], so they are never hidden (a new
     finish never vanishes before its tone is set). Hides via the native [hidden]
     attribute, exactly like the room filter, so it coexists with the pinch FLIP for
     free (a 0-rect hidden tile is skipped by the morph). Selection state on the
     sample swatches is untouched — filtering changes visibility only, so picks
     survive switching tone. */
  function applyShopFilters(grid) {
    var tone = grid.getAttribute("data-active-tone") || "all";
    var material = grid.getAttribute("data-active-material") || "all";
    Array.prototype.slice.call(grid.querySelectorAll("[data-tone], [data-material]")).forEach(function (tile) {
      var toneMatch = tone === "all" || !tile.hasAttribute("data-tone") || tile.getAttribute("data-tone") === tone;
      var materialMatch = material === "all" || tile.getAttribute("data-material") === material;
      tile.hidden = !(toneMatch && materialMatch);
    });
  }

  function initToneFilter() {
    Array.prototype.slice.call(feed.querySelectorAll("[data-tone-filter]")).forEach(function (bar) {
      var sel = bar.getAttribute("data-tone-grid");
      var grid = sel ? feed.querySelector(sel) : null;
      if (!grid) return;
      var chips = Array.prototype.slice.call(bar.querySelectorAll("[data-filter]"));
      if (!chips.length) return;
      function apply(f, writeUrl) {
        if (!chips.some(function (c) { return c.getAttribute("data-filter") === f; })) f = "all";
        chips.forEach(function (c) {
          var on = c.getAttribute("data-filter") === f;
          c.classList.toggle("is-active", on);
          c.setAttribute("aria-pressed", on ? "true" : "false");
        });
        grid.setAttribute("data-active-tone", f);
        applyShopFilters(grid);
        if (writeUrl && window.history && window.history.replaceState) {
          var next = new URL(window.location.href);
          if (f === "all") next.searchParams.delete("tone");
          else next.searchParams.set("tone", f);
          window.history.replaceState({}, "", next.pathname + next.search + next.hash);
        }
      }
      chips.forEach(function (chip) {
        chip.addEventListener("click", function () { apply(chip.getAttribute("data-filter"), true); });
      });
      // ?tone= mirrors ?material= so the desktop menu can deep link "Light wood".
      var initial = "all";
      try { initial = new URLSearchParams(window.location.search).get("tone") || "all"; } catch (e) {}
      apply(initial, false);
    });

    Array.prototype.slice.call(feed.querySelectorAll("[data-material-filter]")).forEach(function (bar) {
      var sel = bar.getAttribute("data-material-grid");
      var grid = sel ? feed.querySelector(sel) : null;
      if (!grid) return;
      var chips = Array.prototype.slice.call(bar.querySelectorAll("[data-material-value]"));
      if (!chips.length) return;
      function apply(material, writeUrl) {
        if (!chips.some(function (chip) { return chip.getAttribute("data-material-value") === material; })) material = "all";
        chips.forEach(function (chip) {
          var on = chip.getAttribute("data-material-value") === material;
          chip.classList.toggle("is-active", on);
          chip.setAttribute("aria-pressed", on ? "true" : "false");
        });
        grid.setAttribute("data-active-material", material);
        applyShopFilters(grid);
        if (writeUrl && window.history && window.history.replaceState) {
          var next = new URL(window.location.href);
          if (material === "all") next.searchParams.delete("material");
          else next.searchParams.set("material", material);
          window.history.replaceState({}, "", next.pathname + next.search + next.hash);
        }
      }
      chips.forEach(function (chip) {
        chip.addEventListener("click", function () { apply(chip.getAttribute("data-material-value"), true); });
      });
      var initial = "all";
      try { initial = new URLSearchParams(window.location.search).get("material") || "all"; } catch (e) {}
      apply(initial, false);
    });
  }

  /* Inspiration offer — reveal the curated swatch group for the active room AND keep
     the offer as the SECOND screen. The blocks lead with kitchen, so for bathroom /
     furniture the leading kitchen blocks are filtered out; without repositioning, the
     offer (rendered after the first block) would float to the top and become the first
     screen. So move it after the first item of the active room (or the first item
     overall when no room), and re-run when the shopper switches room chips. */
  function initInspOffer() {
    // Move the OUTER offer panel (.vmcm-insp__offer <li>), not the inner picker:
    // [data-insp-offer] sits on the .vmcm-offer__pick div, so selecting it ripped the
    // swatch picker out of the panel (broken formatting) and left the panel stranded
    // after the first block (it floated to the top when filtering bathroom/furniture).
    var offer = feed.querySelector(".vmcm-insp__offer");
    if (!offer) return;
    var wall = feed.querySelector(".vmcm-insp__wall");

    function activeRoom() {
      var r = "";
      try { r = new URLSearchParams(window.location.search).get("filter") || ""; } catch (e) {}
      if (!r) r = (window.location.hash || "").replace("#", "");
      return r;
    }
    function applyOffer(room) {
      var groups = Array.prototype.slice.call(offer.querySelectorAll("[data-room]"));
      var groupRoom = groups.some(function (g) { return g.getAttribute("data-room") === room; }) ? room : "default";
      groups.forEach(function (g) { g.hidden = g.getAttribute("data-room") !== groupRoom; });
      if (!wall) return;
      var items = Array.prototype.slice.call(wall.querySelectorAll("[data-insp-item]"));
      var anchor = null;
      if (room && room !== "all") {
        for (var i = 0; i < items.length; i++) {
          if ((items[i].getAttribute("data-category") || "") === room) { anchor = items[i]; break; }
        }
      }
      if (!anchor) anchor = items[0];
      if (anchor) anchor.insertAdjacentElement("afterend", offer);
    }

    applyOffer(activeRoom());
    var bar = feed.querySelector("[data-vmcm-filter]");
    if (bar) {
      Array.prototype.slice.call(bar.querySelectorAll("[data-filter]")).forEach(function (chip) {
        chip.addEventListener("click", function () {
          applyOffer(chip.getAttribute("data-filter"));
          scheduleOfferSnapState();
        });
      });
    }

    function setOfferSnapState(on) {
      feed.classList.toggle("is-insp-offer-active", !!on);
    }

    var snapRaf = 0;
    function updateOfferSnapState() {
      snapRaf = 0;
      var viewport = feed.clientHeight || window.innerHeight || 1;
      var top = offer.offsetTop;
      var bottom = top + offer.offsetHeight;
      var y = feed.scrollTop || 0;
      var before = Math.max(96, viewport * 0.15);
      var after = Math.max(420, viewport * 0.65);
      setOfferSnapState(y >= top - before && y <= bottom + after);
    }
    function scheduleOfferSnapState() {
      if (snapRaf) return;
      snapRaf = requestAnimationFrame(updateOfferSnapState);
    }
    feed.addEventListener("scroll", scheduleOfferSnapState, { passive: true });
    window.addEventListener("resize", scheduleOfferSnapState, { passive: true });
    updateOfferSnapState();
  }

  /* Scroll-down cue on the first inspiration screen — mirrors the pinch-hint reveal:
     fade in on load, fade out + persist on the first real scroll, never nag again. */
  function initScrollCue() {
    var cue = feed.querySelector("[data-scroll-cue]");
    if (!cue) return;
    var key = "velven:scrolled:" + (cue.getAttribute("data-hint-key") || "insp");
    try { if (localStorage.getItem(key) === "1") return; } catch (e) {}
    requestAnimationFrame(function () { cue.classList.add("is-in"); });
    var done = false;
    function dismiss() {
      if (done) return; done = true;
      cue.classList.remove("is-in"); cue.classList.add("is-out");
      try { localStorage.setItem(key, "1"); } catch (e) {}
      feed.removeEventListener("scroll", onScroll);
    }
    function onScroll() { if (feed.scrollTop > 40) dismiss(); }
    feed.addEventListener("scroll", onScroll, { passive: true });
    cue._timer = setTimeout(function () { cue.classList.add("is-out"); }, 12000);
  }

  /* Tools upsell — the shop-all band's "Add to cart" adds The Wrap Tool Kit silently
     (no drawer in this theme) and confirms. The drawer's tool-kit card uses the same
     silent add. The cart-page nudge's "Add" adds the kit
     and re-renders the cart section in place (mirroring send()), so the nudge hides. */
  function initToolUpsell() {
    feed.addEventListener("click", function (e) {
      var band = e.target.closest("[data-tool-add]");
      if (band) {
        e.preventDefault();
        if (band._busy) return;
        var vid = parseInt(band.getAttribute("data-variant"), 10);
        if (!vid) return;
        band._busy = true;
        var lbl = band.querySelector("[data-tool-addlabel]") || band;
        var orig = lbl.textContent;
        lbl.textContent = "Adding…";
        standardCartAdd([{ id: vid, quantity: 1 }], band, "product", function () {
          return fetch(ADD, {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
          }).then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); });
        })
        .then(function () {
          lbl.textContent = band.getAttribute("data-added-label") || "Added";
          band.classList.add("is-added");
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        })
        .catch(function () { lbl.textContent = orig; band._busy = false; });
        return;
      }
      var nudge = e.target.closest("[data-carttool-add]");
      if (nudge) {
        e.preventDefault();
        if (nudge._busy) return;
        var nvid = parseInt(nudge.getAttribute("data-variant"), 10);
        if (!nvid) return;
        var cartEl = feed.querySelector("[data-cart]");
        var sid = cartEl ? cartEl.getAttribute("data-section-id") : null;
        nudge._busy = true;
        nudge.textContent = "Adding…";
        standardCartAdd([{ id: nvid, quantity: 1 }], nudge, "cart", function () {
          return fetch(ADD, {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ items: [{ id: nvid, quantity: 1 }] })
          }).then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          if (!sid) { window.location.reload(); return; }
          return fetch("/cart?sections=" + encodeURIComponent(sid)).then(function (r) { return r.json(); })
            .then(function (data) {
              var html = data && data[sid];
              var current = feed.querySelector("[data-cart]");
              if (html && current) {
                var fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-cart]");
                if (fresh) { current.replaceWith(fresh); return; }
              }
              window.location.reload();
            });
        }).catch(function () { window.location.reload(); });
        return;
      }
    });
  }

  function applyEase(on, silent) {
    eased = on;
    root.style.setProperty("--ease-scale", on ? EASED : FULL);
    feed.classList.toggle("is-eased", on);
    try { sessionStorage.setItem(KEY, on ? "1" : "0"); } catch (e) {}
    var toggle = document.querySelector("[data-ease-toggle]");
    if (toggle) toggle.setAttribute("aria-pressed", on ? "true" : "false");
    if (!silent && liveEl) liveEl.textContent = on ? "Comfort view on" : "Full view on";
  }

  /* Pinch / comfort-ease gestures — only on pages that actually pinch: the snap
     feeds (panels scale via comfort-ease) and the gallery grids (data-pinch-grid
     resizes). Plain page scrollers (cart / search / 404) have neither, so skip the
     wiring entirely and leave native browser zoom intact. */
  // Multi-column product grids (all-finishes, the inspiration wall) opt out with
  // data-no-pinch: they scroll like any page and native browser zoom stays intact.
  var pinchUse = !feed.hasAttribute("data-no-pinch") && (panels.length > 0 || !!feed.querySelector("[data-pinch-grid]"));
  if (pinchUse) {
  /* iOS Safari: gesture events carry event.scale directly */
  var startScale = 1;
  feed.addEventListener("gesturestart", function (e) {
    e.preventDefault(); usingGesture = true; startScale = e.scale;
  }, { passive: false });
  feed.addEventListener("gesturechange", function (e) { e.preventDefault(); }, { passive: false });
  feed.addEventListener("gestureend", function (e) {
    e.preventDefault();
    var delta = e.scale - startScale;        // >0 pinch-out, <0 pinch-in
    var g = pinchTarget();
    if (g) {
      if (delta > TH) stepGrid(g, -1);       // spread -> zoom in (fewer per row)
      else if (delta < -TH) stepGrid(g, 1);  // pinch  -> zoom out (more per row)
    } else {
      if (delta < -TH) applyEase(true);
      else if (delta > TH) applyEase(false);
    }
    usingGesture = false;
  }, { passive: false });

  /* Android Chrome / others: two-finger touch distance tracking */
  var startDist = null, lastRatio = 1;
  function dist(t) {
    return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
  }
  feed.addEventListener("touchstart", function (e) {
    if (usingGesture) return;
    if (e.touches.length === 2) { startDist = dist(e.touches); lastRatio = 1; }
  }, { passive: false });
  feed.addEventListener("touchmove", function (e) {
    if (usingGesture || startDist == null) return;
    if (e.touches.length === 2) {
      e.preventDefault();                    // stop Android pinch + scroll fight
      lastRatio = dist(e.touches) / startDist;
    }
  }, { passive: false });
  feed.addEventListener("touchend", function (e) {
    if (usingGesture || startDist == null) return;
    if (e.touches.length < 2) {
      var g = pinchTarget();
      if (g) {
        if (lastRatio > 1 + TH) stepGrid(g, -1);      // fingers spread -> fewer per row
        else if (lastRatio < 1 - TH) stepGrid(g, 1);  // fingers pinch  -> more per row
      } else {
        if (lastRatio > 1 + TH) applyEase(true);      // fingers spread -> ease out
        else if (lastRatio < 1 - TH) applyEase(false);// fingers pinch  -> full
      }
      startDist = null; lastRatio = 1;
    }
  }, { passive: true });

  /* Desktop: discreet toggle (shown on non-touch) + optional Cmd/Ctrl-wheel */
  var coarse = window.matchMedia("(pointer: coarse)").matches;
  // Desktop: always the eased (comfort / matted) view, no toggle button.
  if (!coarse) applyEase(true, true);
  // Ctrl/Cmd + wheel resizes a gallery grid (shop / inspiration); it no longer
  // toggles comfort-ease (desktop stays eased).
  feed.addEventListener("wheel", function (e) {
    if (!(e.ctrlKey || e.metaKey)) return;
    var g = pinchTarget();
    if (!g) return;
    e.preventDefault();
    stepGrid(g, e.deltaY > 0 ? 1 : -1);                 // wheel up = zoom in (fewer per row)
  }, { passive: false });
  } /* end pinch guard (pinchUse) */

  /* --------------------------------------------------------------------------
     Magnetic wheel + keyboard (desktop). Touch keeps native CSS scroll-snap, so
     this only governs mouse / trackpad: one deliberate gesture glides exactly one
     panel, locked briefly so a trackpad burst counts once. Tall / growable panels
     (FAQ, the sample grid) scroll through internally first and advance at the edge.
     ------------------------------------------------------------------------ */
  if (verticalMagnetics && panels.length > 1) {
    var snapLock = false, snapTimer = null, wheelQuiet = null;
    var SNAP_MS = 900, QUIET_MS = 150, lastSnapAt = 0, MIN_LOCK = 640, tweenRaf = 0;
    // Mouse-wheel smooth-scroll state. Each advance is a clean eased tween to a panel, with
    // native scroll-snap DISABLED for the duration so the browser does not fight the
    // animation (that tug was the real cause of the jitter). Re-targeting mid glide chains.
    var mouseGlideActive = false, mTargetIdx = -1, mRaf = 0, mLastAdvance = 0;
    var mAcc = 0, mAccDir = 0, mAccTimer = null;
    var MOUSE_TH = 45, MIN_GAP = 90, GLIDE_DUR = 780;
    // Release a snap: stop the glide, unlock, and restore native scrolling (overflow
    // is hidden during the lock to actually stop a touchpad's non-cancelable inertia).
    // Always restore scroll-snap on release: swSnap/mAdvance disable it during a glide,
    // and a cancelled glide must never leave the feed stuck with snap off (would stop
    // rooms gently re-aligning until the next completed glide).
    function releaseSnap() { cancelAnimationFrame(tweenRaf); snapLock = false; feed.style.overflowY = ""; feed.style.scrollSnapType = ""; }
    // Manual eased scroll — works while overflow is hidden (where behavior:smooth may
    // not animate) so the snap glides to the panel instead of jumping.
    function tweenScroll(to) {
      cancelAnimationFrame(tweenRaf);
      var from = feed.scrollTop, d = to - from;
      if (reduceMotion || Math.abs(d) < 1) { feed.scrollTop = to; return; }
      var t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / 560);
        feed.scrollTop = from + d * easeGlide(p);
        if (p < 1) tweenRaf = requestAnimationFrame(step);
      }
      tweenRaf = requestAnimationFrame(step);
    }
    // A clean eased tween to one panel, with snap turned OFF while it runs so the browser
    // cannot tug against it (the real smoothness fix). endMGlide restores snap exactly on
    // the target, which is already a snap point, so there is no jump. Calling mAdvance again
    // mid glide re-aims from the current spot, so deliberate scrolling chains smoothly.
    function endMGlide() {
      if (mTargetIdx >= 0) feed.scrollTop = navEls[mTargetIdx].offsetTop;
      feed.style.scrollSnapType = ""; mouseGlideActive = false; mRaf = 0; mTargetIdx = -1;
    }
    function mAdvance(dir) {
      cancelAnimationFrame(tweenRaf); feed.style.overflowY = "";   // drop any leftover touchpad lock
      var base = mouseGlideActive && mTargetIdx >= 0 ? mTargetIdx : activeIndex();
      mTargetIdx = Math.max(0, Math.min(navEls.length - 1, base + dir));
      mouseGlideActive = true;
      feed.style.scrollSnapType = "none";   // stop native proximity snap fighting the tween
      cancelAnimationFrame(mRaf);
      var from = feed.scrollTop, to = navEls[mTargetIdx].offsetTop, d = to - from, t0 = null;
      if (reduceMotion || d === 0) { endMGlide(); return; }
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / GLIDE_DUR);
        feed.scrollTop = from + d * easeGlide(p);               // slowed, smoothed glide
        if (p < 1) mRaf = requestAnimationFrame(step); else endMGlide();
      }
      mRaf = requestAnimationFrame(step);
    }
    // Desktop wheel felt too touchy — a tiny nudge jumped a whole panel. Require a
    // little accumulated intent before a snap fires (touch swipe is handled
    // separately below, so mobile is unaffected).
    var wheelAcc = 0, wheelDir = 0, wheelAccTimer = null, WHEEL_TH = 130;

    // Desktop nav targets = the panels PLUS the footer, so wheel / keyboard can
    // reach the footer too (mobile swipe already includes it). Without this the
    // snap clamped at the last panel and the footer was unreachable on desktop.
    var navEls = panels.slice();
    var navFooter = feed.querySelector(".vmcm-footer");
    if (navFooter) navEls.push(navFooter);

    // A feed with a tall free-scroll form (the sample-box "pick your six" grid)
    // fights the magnetic wheel/keyboard snap on desktop: the snap-to-panel lock
    // makes the long swatch grid feel stuck. Let native CSS proximity snap own
    // those feeds (touch swipe below is unaffected, so mobile is unchanged).
    var freeScroll = !!feed.querySelector("#vmcm-sample-inside");

    function activeIndex() {
      var top = feed.scrollTop + Math.min(20, feed.clientHeight * 0.1);
      for (var i = 0; i < navEls.length; i++) {
        var pt = navEls[i].offsetTop;
        if (top >= pt && top < pt + navEls[i].offsetHeight) return i;
      }
      var best = 0, bestD = Infinity;
      for (var j = 0; j < navEls.length; j++) {
        var d = Math.abs(navEls[j].offsetTop - feed.scrollTop);
        if (d < bestD) { bestD = d; best = j; }
      }
      return best;
    }
    function snapTo(i) {
      i = Math.max(0, Math.min(navEls.length - 1, i));
      snapLock = true;
      lastSnapAt = Date.now();
      // Block native scrolling for the lock so a touchpad's NON-cancelable inertial
      // momentum cannot carry past the target panel (preventDefault and re-setting
      // scrollTop are both ignored mid-inertia; overflow:hidden actually stops it).
      // The programmatic scroll below still positions the feed; releaseSnap restores.
      feed.style.overflowY = "hidden";
      tweenScroll(navEls[i].offsetTop);
      clearTimeout(snapTimer);
      snapTimer = setTimeout(releaseSnap, reduceMotion ? 90 : SNAP_MS);
    }
    // (No scrollend-based early release: a touchpad's momentum wheel kept arriving
    // after the snap settled and fired a SECOND snap, skipping a panel. The lock now
    // clears a short QUIET_MS after the wheel actually stops — see the wheel handler.)

    if (!freeScroll) {
    feed.addEventListener("wheel", function (e) {
      if (e.ctrlKey || e.metaKey) return;          // ctrl/cmd + wheel = grid zoom

      // A real mouse wheel arrives as large, discrete notches with no inertia. Drive a
      // fluid, continuous glide: a small intent gate ignores stray micro notches, a short
      // gap between advances keeps one flick to one panel, and deliberate scrolling flows
      // smoothly panel to panel. Touchpads (small, high frequency, deltaMode 0 deltas) fall
      // through to the inertia anti-skip lock below, unchanged.
      if (e.deltaMode !== 0 || Math.abs(e.deltaY) >= 40) {
        var mdir = e.deltaY > 0 ? 1 : -1;
        if (mTargetIdx < 0) {
          // not gliding: let a tall panel (e.g. PDP details) scroll internally first
          var mcur = activeIndex(), mcp = navEls[mcur];
          var mtop = mcp.offsetTop, mbot = mtop + mcp.offsetHeight, mEDGE = 4;
          if (mdir > 0 && (feed.scrollTop + feed.clientHeight) < mbot - mEDGE) { mAcc = 0; mAccDir = 0; return; }
          if (mdir < 0 && feed.scrollTop > mtop + mEDGE) { mAcc = 0; mAccDir = 0; return; }
        }
        e.preventDefault();
        if (mdir !== mAccDir) { mAccDir = mdir; mAcc = 0; }
        mAcc += Math.abs(e.deltaY);
        clearTimeout(mAccTimer);
        mAccTimer = setTimeout(function () { mAcc = 0; mAccDir = 0; }, 160);
        if (mAcc < MOUSE_TH) return;                 // not enough intent yet
        var mnow = Date.now();
        if (mnow - mLastAdvance < MIN_GAP) { mAcc = 0; return; }   // one flick burst = one advance
        mLastAdvance = mnow; mAcc = 0; mAccDir = 0;
        mAdvance(mdir);
        return;
      }

      if (snapLock) {
        // Don't trap the wheel during the post-snap lock if the panel under us can
        // still scroll internally in this direction (this was the "stuck, then moves
        // after a moment" feel on the tall sample-box selection grid). Release and
        // let it scroll; otherwise hold the lock so a snap does not double-fire.
        var ld = e.deltaY > 0 ? 1 : (e.deltaY < 0 ? -1 : 0);
        var lap = navEls[activeIndex()];
        if (lap && ld) {
          var lTop = lap.offsetTop, lBot = lTop + lap.offsetHeight, lE = 4;
          if ((ld > 0 && (feed.scrollTop + feed.clientHeight) < lBot - lE) ||
              (ld < 0 && feed.scrollTop > lTop + lE)) { releaseSnap(); clearTimeout(snapTimer); clearTimeout(wheelQuiet); return; }
        }
        e.preventDefault();
        // Hold the lock (native scroll stays blocked via overflow:hidden) through the
        // whole gesture: at least MIN_LOCK after the snap AND until the wheel quiets,
        // so a touchpad flick's inertia can never carry into the next panel.
        clearTimeout(snapTimer);
        clearTimeout(wheelQuiet);
        var rem = Math.max(QUIET_MS, MIN_LOCK - (Date.now() - lastSnapAt));
        wheelQuiet = setTimeout(releaseSnap, rem);
        return;
      }
      var dir = e.deltaY > 0 ? 1 : (e.deltaY < 0 ? -1 : 0);
      if (!dir) return;
      var idx = activeIndex();
      var p = navEls[idx];
      var top = p.offsetTop, bottom = top + p.offsetHeight, EDGE = 4;
      // tall / growable panel: let the wheel scroll through it natively until the edge
      if (dir > 0 && (feed.scrollTop + feed.clientHeight) < bottom - EDGE) { wheelAcc = 0; wheelDir = 0; return; }
      if (dir < 0 && feed.scrollTop > top + EDGE) { wheelAcc = 0; wheelDir = 0; return; }
      e.preventDefault();
      // accumulate deliberate intent so a small nudge no longer flips a whole panel
      if (dir !== wheelDir) { wheelDir = dir; wheelAcc = 0; }
      wheelAcc += Math.abs(e.deltaY);
      clearTimeout(wheelAccTimer);
      wheelAccTimer = setTimeout(function () { wheelAcc = 0; wheelDir = 0; }, 170);
      if (wheelAcc < WHEEL_TH) return;
      wheelAcc = 0; wheelDir = 0;
      snapTo(idx + dir);
    }, { passive: false });

    document.addEventListener("keydown", function (e) {
      var t = e.target;
      if (t && t.closest && t.closest("input, textarea, select, [contenteditable], dialog, details")) return;
      var i = activeIndex();
      if (e.key === "ArrowDown" || e.key === "PageDown") { e.preventDefault(); snapTo(i + 1); }
      else if (e.key === "ArrowUp" || e.key === "PageUp") { e.preventDefault(); snapTo(i - 1); }
      else if (e.key === "Home") { e.preventDefault(); snapTo(0); }
      else if (e.key === "End") { e.preventDefault(); snapTo(navEls.length - 1); }
    });
    } /* end magnetic wheel + keyboard (skipped for free-scroll feeds like the sample box) */

    /* Touch: TikTok / Reels feel — a small deliberate vertical swipe OR a quick
       flick advances exactly one SECTION, where sections = the panels AND the
       footer (so closing -> footer takes the same small swipe as any other, both
       ways). Native scroll-snap alone needed a near full-screen throw, so a normal
       swipe rested "stuck half way". Tall sections still scroll internally first
       (edge check); horizontal carousels and two-finger pinches keep their own. */
    var swEls = panels.slice();
    var swFooter = feed.querySelector(".vmcm-footer");
    if (swFooter) swEls.push(swFooter);
    function swActive() {
      var top = feed.scrollTop + Math.min(20, feed.clientHeight * 0.1);
      for (var i = 0; i < swEls.length; i++) { var pt = swEls[i].offsetTop; if (top >= pt && top < pt + swEls[i].offsetHeight) return i; }
      var best = 0, bd = Infinity;
      for (var j = 0; j < swEls.length; j++) { var d = Math.abs(swEls[j].offsetTop - feed.scrollTop); if (d < bd) { bd = d; best = j; } }
      return best;
    }
    function swSnap(i) {
      i = Math.max(0, Math.min(swEls.length - 1, i));
      snapLock = true;
      // Drive the swipe with the SAME eased JS tween as the desktop glide, with native
      // scroll-snap turned OFF for the duration. The old scrollTo({behavior:"smooth"})
      // was UA-timed and the proximity snap re-tugged at the end of it — that tug was the
      // swipe jank. A hand-eased tween over GLIDE_DUR lands exactly on the panel (a snap
      // point), then snap resumes with no jump.
      cancelAnimationFrame(tweenRaf);
      var from = feed.scrollTop, to = swEls[i].offsetTop, d = to - from, t0 = null;
      if (reduceMotion || Math.abs(d) < 1) {
        feed.style.scrollSnapType = "";   // a prior interrupted glide may have left it off
        feed.scrollTop = to;
        clearTimeout(snapTimer);
        snapTimer = setTimeout(function () { snapLock = false; }, 90);
        return;
      }
      feed.style.scrollSnapType = "none";
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / GLIDE_DUR);
        feed.scrollTop = from + d * easeGlide(p);
        if (p < 1) tweenRaf = requestAnimationFrame(step);
        else { feed.scrollTop = to; feed.style.scrollSnapType = ""; }
      }
      tweenRaf = requestAnimationFrame(step);
      clearTimeout(snapTimer);
      snapTimer = setTimeout(function () { snapLock = false; }, SNAP_MS);
    }
    var swY = 0, swX = 0, swT = 0, swIdx = 0, swOn = false;
    feed.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1) { swOn = false; return; }
      swOn = true;
      swY = e.touches[0].clientY; swX = e.touches[0].clientX;
      swT = Date.now(); swIdx = swActive();
    }, { passive: true });
    feed.addEventListener("touchend", function (e) {
      if (!swOn || usingGesture) { swOn = false; return; }
      swOn = false;
      var tt = e.changedTouches && e.changedTouches[0];
      if (!tt) return;
      var dy = tt.clientY - swY, dx = tt.clientX - swX, dt = Date.now() - swT;
      if (Math.abs(dx) >= Math.abs(dy)) return;            // horizontal gesture — ignore
      var vy = Math.abs(dy) / Math.max(dt, 1);             // px per ms
      if (Math.abs(dy) < 20 && vy < 0.3) return;           // too small to be a deliberate swipe
      var el = swEls[swIdx];
      if (el) {                                            // tall section: let it scroll internally, advance only at the edge
        var top = el.offsetTop, bottom = top + el.offsetHeight, EDGE = 6;
        if (dy < 0 && (feed.scrollTop + feed.clientHeight) < bottom - EDGE) return;
        if (dy > 0 && feed.scrollTop > top + EDGE) return;
      }
      swSnap(swIdx + (dy < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* --------------------------------------------------------------------------
     5. Drawer — centre detection + colour hydration from MATERIALS
     ------------------------------------------------------------------------ */
  var drawer = feed.querySelector(".vmcm-drawer__track");
  if (drawer) {
    var swatches = Array.prototype.slice.call(drawer.querySelectorAll(".vmcm-swatch"));
    swatches.forEach(function (sw) {
      var m = byHandle[sw.getAttribute("data-swatch-handle")];
      if (!m) return;
      var chip = sw.querySelector(".vmcm-swatch__chip");
      if (chip) {
        chip.style.setProperty("--swatch-color", m.plane);
        if (m.swatchImage) chip.setAttribute("data-swatch-image", m.swatchImage);
      }
      var price = sw.querySelector(".vmcm-swatch__price");
      if (price) {
        var from = displayFromSize(m);
        if (from) price.textContent = "From " + money(from.price);
      }
    });

    function loadSwatchImage(sw) {
      var chip = sw.querySelector(".vmcm-swatch__chip[data-swatch-image]");
      if (!chip) return;
      chip.style.backgroundImage = "url(" + chip.getAttribute("data-swatch-image") + ")";
      chip.removeAttribute("data-swatch-image");
    }

    if ("IntersectionObserver" in window) {
      var swatchImageIO = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadSwatchImage(entry.target);
          observer.unobserve(entry.target);
        });
      }, { root: drawer, rootMargin: "0px 50% 0px 50%", threshold: 0 });
      swatches.forEach(function (sw) { swatchImageIO.observe(sw); });
    } else {
      var loadNearbySwatches = function () {
        var dr = drawer.getBoundingClientRect();
        var margin = dr.width / 2;
        swatches.forEach(function (sw) {
          var r = sw.getBoundingClientRect();
          if (r.right >= dr.left - margin && r.left <= dr.right + margin) loadSwatchImage(sw);
        });
      };
      drawer.addEventListener("scroll", loadNearbySwatches, { passive: true });
      window.addEventListener("resize", loadNearbySwatches);
      loadNearbySwatches();
    }

    // Highlight the swatch nearest the track centre, driven by the track's own
    // scroll (rAF-debounced) so it tracks during momentum. (The old
    // IntersectionObserver ratio gate clipped the window to 20% of the track and
    // required 60% of a 70vw swatch to overlap it — unreachable on mobile, so the
    // highlight never moved off swatch 0.)
    var centerRaf = 0;
    function markCenter() {
      centerRaf = 0;
      var dr = drawer.getBoundingClientRect();
      var cx = dr.left + dr.width / 2;
      var best = null, bestD = Infinity;
      for (var i = 0; i < swatches.length; i++) {
        var r = swatches[i].getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - cx);
        if (d < bestD) { bestD = d; best = swatches[i]; }
      }
      if (best && !best.classList.contains("is-center")) {
        for (var j = 0; j < swatches.length; j++) swatches[j].classList.remove("is-center");
        best.classList.add("is-center");
      }
    }
    // Magnetic settle: once a swipe (and its momentum) come to rest, glide the
    // nearest swatch smoothly to dead-centre so a swipe always lands cleanly on
    // ONE swatch. scroll-snap-stop handles the common one-per-swipe case; this
    // catches a low-velocity flick that would otherwise rest between two.
    var settleTimer = 0, settling = false;
    function centerOffset(sw) {
      var dr = drawer.getBoundingClientRect(), r = sw.getBoundingClientRect();
      return (r.left + r.width / 2) - (dr.left + dr.width / 2);
    }
    function settleSwatch() {
      settleTimer = 0;
      if (settling) return;
      var best = null, bestD = Infinity;
      for (var i = 0; i < swatches.length; i++) {
        var d = Math.abs(centerOffset(swatches[i]));
        if (d < bestD) { bestD = d; best = swatches[i]; }
      }
      if (!best || bestD <= 1) return;
      settling = true;
      drawer.scrollTo({ left: drawer.scrollLeft + centerOffset(best), behavior: reduceMotion ? "auto" : "smooth" });
      setTimeout(function () { settling = false; }, reduceMotion ? 60 : 420);
    }
    // A rail that starts at the gutter (data-rail-start) snaps each card to the
    // left edge natively, so the centre-settle glide would fight the snap.
    var railStart = drawer.hasAttribute("data-rail-start");
    drawer.addEventListener("scroll", function () {
      if (!centerRaf) centerRaf = requestAnimationFrame(markCenter);
      if (!railStart && !settling) { clearTimeout(settleTimer); settleTimer = setTimeout(settleSwatch, 90); }
    }, { passive: true });
    markCenter();   // set the true starting centre (no hard pin on swatch 0)
  }

  /* --------------------------------------------------------------------------
     Horizontal image catalog — the PDP hero and the home Black Oak panel.
     Native scroll-snap handles the swipe on touch; on desktop a mouse drags
     the strip to scroll (see the fine-pointer block below), and a plain
     click/tap that wasn't a drag opens the zoom modal (assets/vmcm-zoom.js)
     on the active photo instead. An animated cue invites the gesture until
     the shopper first interacts. Any [data-vmcm-gal]; no-op without one.
     ------------------------------------------------------------------------ */
  Array.prototype.slice.call(feed.querySelectorAll("[data-vmcm-gal]")).forEach(function (gal) {
    var track = gal.querySelector("[data-vmcm-gal-track]");
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    var hint = gal.querySelector("[data-vmcm-gal-hint]");
    var dots = Array.prototype.slice.call(gal.querySelectorAll("[data-vmcm-gal-dot]"));
    var current = gal.querySelector("[data-vmcm-gal-current]");
    var galPanel = gal.closest(".vmcm-panel");
    var fine = window.matchMedia("(pointer: fine)").matches;
    var interacted = false, lastGround = "";

    if (hint) requestAnimationFrame(function () { hint.classList.add("is-in"); });
    function drop() { if (interacted) return; interacted = true; if (hint) hint.classList.add("is-out"); }

    function activeIdx() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var mid = slides[i].offsetLeft + slides[i].clientWidth / 2, d = Math.abs(mid - c);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }
    // Reynard-style mapped ground: the panel background crossfades to the active
    // finish's ground as you browse (each slide carries data-ground / data-ink).
    function applyGround(i) {
      var s = slides[i]; if (!s || !galPanel) return;
      var g = s.getAttribute("data-ground"); if (!g || g === lastGround) return;
      lastGround = g;
      var ink = s.getAttribute("data-ink") || "light";
      galPanel.style.backgroundColor = g;
      galPanel.setAttribute("data-ink", ink);
      galPanel.setAttribute("data-bg", g);
      galPanel.setAttribute("data-chrome", ink === "dark" ? "solid-dark" : "solid-light");
      if (galPanel === activePanel) applyChrome(galPanel);
    }
    function markDots() { var a = activeIdx(); for (var i = 0; i < dots.length; i++) dots[i].classList.toggle("is-on", i === a); if (current) current.textContent = a + 1; applyGround(a); }
    function goToSlide(i) {
      var next = ((i % slides.length) + slides.length) % slides.length;
      track.scrollTo({ left: slides[next].offsetLeft, behavior: reduceMotion ? "auto" : "smooth" });
      applyGround(next);
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle("is-on", d === next);
      if (current) current.textContent = next + 1;
    }
    var galRaf = 0;
    track.addEventListener("scroll", function () {
      drop();
      if (!galRaf) galRaf = requestAnimationFrame(function () { galRaf = 0; markDots(); });
    }, { passive: true });
    markDots();

    // Desktop (fine pointer): a plain mouse cannot scroll an overflow-x div by
    // click-drag, so wire pointer-drag-to-scroll here. Touch already scrolls
    // natively via scroll-snap. A desktop click advances the PDP gallery; the
    // drag-distance guard below keeps a drag release from also advancing.
    var dragState = null, lastDragDistance = 0;
    if (fine) {
      gal.classList.add("vmcm-gal--fine");
      track.addEventListener("pointerdown", function (e) {
        if (e.target.closest("a, button, [data-handle]")) return;
        dragState = { id: e.pointerId, startX: e.clientX, scrollStart: track.scrollLeft, moved: 0 };
        track.setPointerCapture(e.pointerId);
        track.classList.add("is-dragging");
      });
      track.addEventListener("pointermove", function (e) {
        if (!dragState || e.pointerId !== dragState.id) return;
        var dx = e.clientX - dragState.startX;
        dragState.moved = Math.max(dragState.moved, Math.abs(dx));
        track.scrollLeft = dragState.scrollStart - dx;
      });
      var endDrag = function (e) {
        if (!dragState || e.pointerId !== dragState.id) return;
        lastDragDistance = dragState.moved;
        drop();
        track.classList.remove("is-dragging");
        dragState = null;
      };
      track.addEventListener("pointerup", endDrag);
      track.addEventListener("pointercancel", endDrag);
    }
    track.addEventListener("click", function (e) {
      if (e.target.closest("a, button, [data-handle]")) return;  // let a finish link / add-to-cart act
      if (fine && lastDragDistance > 6) { lastDragDistance = 0; return; }  // that click followed a real drag, not a tap
      lastDragDistance = 0;
      drop();
      // Finishes catalog (any pointer) and the desktop PDP gallery advance on a
      // tap: click the RIGHT half to go to the next swatch, the LEFT half to step
      // back to the swatch on the left. Touch also swipes both ways natively.
      if (gal.classList.contains("vmcm-gal--finishes") || fine) {
        var r = track.getBoundingClientRect();
        var dir = (e.clientX - r.left) < r.width / 2 ? -1 : 1;
        goToSlide(activeIdx() + dir);
        return;
      }
      if (window.VelvenZoom) window.VelvenZoom.open(slides[activeIdx()], gal);
    });
  });

  /* --------------------------------------------------------------------------
     6. Selection sheet — open from any [data-handle], pick size, express add
     ------------------------------------------------------------------------ */
  var sheet = document.querySelector("[data-selection-sheet]");
  var sheetEls = sheet ? {
    title: sheet.querySelector("[data-sheet-title]"),
    chip: sheet.querySelector("[data-sheet-chip]"),
    finish: sheet.querySelector("[data-sheet-finish]"),
    sizes: sheet.querySelector("[data-sheet-sizes]"),
    cta: sheet.querySelector("[data-sheet-cta]"),
    error: sheet.querySelector("[data-sheet-error]"),
    link: sheet.querySelector("[data-sheet-link]"),
    done: sheet.querySelector("[data-sheet-done]"),
    ship: sheet.querySelector("[data-sheet-ship]"),
    shipbar: sheet.querySelector("[data-sheet-shipbar]"),
    shipmsg: sheet.querySelector("[data-sheet-shipmsg]"),
    shiptrack: sheet.querySelector("[data-sheet-shiptrack]"),
    shipfill: sheet.querySelector("[data-sheet-shipfill]"),
    sampleCredit: sheet.querySelector("[data-sheet-sample-credit]"),
    stock: sheet.querySelector("[data-sheet-stock]"),
    preorder: sheet.querySelector("[data-sheet-preorder]"),
    restock: sheet.querySelector("[data-sheet-restock]"),
    metres: sheet.querySelector("[data-sheet-metres]"),
    cutting: sheet.querySelector("[data-sheet-cutting]"),
    metresVal: sheet.querySelector("[data-metres-value]"),
    metresTotal: sheet.querySelector("[data-metres-total]"),
    metresDec: sheet.querySelector("[data-metres-dec]"),
    metresInc: sheet.querySelector("[data-metres-inc]"),
    expressForm: sheet.querySelector("[data-express-checkout-form]"),
    expressVariant: sheet.querySelector("[data-express-checkout-variant]"),
    expressQuantity: sheet.querySelector("[data-express-checkout-quantity]")
  } : null;
  var CTA_LABEL = (sheetEls && sheetEls.cta) ? sheetEls.cta.textContent : "Add to cart";

  // Keep free-shipping progress tied to the current cart subtotal. A selection
  // does not count until it has actually been added, so the bar always answers
  // the same question as the cart: how much more does this order need?
  var FREE_SHIP_GOAL = sheet ? (parseInt(sheet.getAttribute("data-ship-free-from"), 10) || 0) : 0;
  var sheetCartTotal = 0;
  var sheetCart = null;
  var sheetCartLifetime = 0;
  var sheetAddComplete = false;
  var sheetAddPending = 0;

  function sheetAddInFlight() {
    return (window.VelvenSampleProgress && window.VelvenSampleProgress.isRemoving()) ||
      (sheetEls && sheetEls.cta && sheetEls.cta.getAttribute("aria-busy") === "true");
  }

  document.addEventListener("velven:cart-add", function (event) {
    sheetAddPending += event.detail.pending ? 1 : -1;
    sheetCartLifetime++;
    sheetCart = null;
    renderSheetShipProgress();
    syncExpressCheckout();
    if (!sheetAddPending && !sheetAddInFlight()) readSheetCartProgress();
  });

  function selectedLineValue() {
    if (!activePerPrice) return 0;
    return activePerPrice * (activeIsRoll ? sheetMetres : 1);
  }

  function setSheetShipProgress(message, amount, state) {
    if (!sheetEls || !sheetEls.shipbar) return;
    var safeAmount = Math.max(0, Math.min(FREE_SHIP_GOAL, amount || 0));
    var ratio = FREE_SHIP_GOAL > 0 ? safeAmount / FREE_SHIP_GOAL : 0;
    sheetEls.shipbar.setAttribute("aria-busy", state === "loading" ? "true" : "false");
    sheetEls.shipbar.dataset.shipState = state || "progress";
    if (sheetEls.shipmsg) sheetEls.shipmsg.textContent = message;
    if (sheetEls.shipfill) sheetEls.shipfill.style.transform = "scaleX(" + ratio + ")";
    if (sheetEls.shiptrack) {
      sheetEls.shiptrack.setAttribute("aria-valuenow", String(Math.round(safeAmount / 100)));
      sheetEls.shiptrack.setAttribute("aria-valuetext", message);
    }
  }

  function freeShipProgress(total) {
    var safeTotal = Math.max(0, Number(total) || 0);
    return {
      amount: Math.min(FREE_SHIP_GOAL, safeTotal),
      remaining: Math.max(0, FREE_SHIP_GOAL - safeTotal),
      unlocked: safeTotal >= FREE_SHIP_GOAL
    };
  }

  function renderSheetShipProgress() {
    if (!sheetEls || !sheetEls.shipbar) return;
    if (!sheetCart) {
      setSheetShipProgress("Checking free shipping…", 0, "loading");
      return;
    }

    var progress = freeShipProgress(sheetCartTotal);
    if (progress.unlocked) {
      setSheetShipProgress("You've unlocked free shipping.", progress.amount, "free");
    } else {
      setSheetShipProgress("You're " + money(progress.remaining) + " away from free shipping.", progress.amount, "progress");
    }
  }

  function readSheetCartProgress() {
    if (!sheetEls) return;
    var lifetime = sheetCartLifetime;
    var request = window.VelvenSampleProgress ? window.VelvenSampleProgress.read() : fetch(ROOT.replace(/\/$/, "") + "/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) {
      if (!r.ok) throw new Error("cart read failed");
      return r.json();
    });
    request.then(function (c) {
      if (lifetime !== sheetCartLifetime || sheetAddPending) return;
      sheetCartTotal = Math.max(0, Number(c.total_price) || 0);
      sheetCart = c;
      if (window.VelvenSampleProgress) window.VelvenSampleProgress.render(c, { isRoll: activeIsRoll });
      renderSheetShipProgress();
      syncExpressCheckout();
    }).catch(function () {
      if (lifetime !== sheetCartLifetime || sheetAddPending) return;
      setSheetShipProgress("Free shipping on orders over $149.", 0, "progress");
    });
  }

  var lastTrigger = null, activeVariant = 0, activeAvailable = false;
  // Own the page lock for the sheet's entire lifecycle. Fixed positioning keeps
  // iOS and zoomed mobile viewports from exposing the document's overscroll gap;
  // the focused sheet content remains the only scrollable surface.
  var sheetScrollLock = {
    active: false,
    scrollY: 0,
    body: null,
    html: null,
    feed: null,
    feedWasInert: false,
    feedOverflow: "",
    feedScrollTop: 0,
    lock: function () {
      if (this.active) return;
      this.active = true;
      this.scrollY = window.scrollY || window.pageYOffset || 0;
      this.body = {
        position: document.body.style.position,
        top: document.body.style.top,
        width: document.body.style.width,
        overflow: document.body.style.overflow,
        overscrollBehavior: document.body.style.overscrollBehavior
      };
      this.html = {
        overflow: document.documentElement.style.overflow,
        overscrollBehavior: document.documentElement.style.overscrollBehavior
      };
      document.documentElement.style.overflow = "hidden";
      document.documentElement.style.overscrollBehavior = "none";
      document.body.style.position = "fixed";
      document.body.style.top = "-" + this.scrollY + "px";
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";
      document.body.style.overscrollBehavior = "none";
      this.feed = feed;
      if (this.feed) {
        this.feedWasInert = this.feed.hasAttribute("inert");
        this.feedOverflow = this.feed.style.overflow;
        this.feedScrollTop = this.feed.scrollTop;
        this.feed.style.overflow = "hidden";
        this.feed.setAttribute("inert", "");
      }
    },
    unlock: function () {
      if (!this.active) return;
      var y = this.scrollY;
      var body = this.body;
      var html = this.html;
      var lockedFeed = this.feed;
      if (body) {
        document.body.style.position = body.position;
        document.body.style.top = body.top;
        document.body.style.width = body.width;
        document.body.style.overflow = body.overflow;
        document.body.style.overscrollBehavior = body.overscrollBehavior;
      }
      if (html) {
        document.documentElement.style.overflow = html.overflow;
        document.documentElement.style.overscrollBehavior = html.overscrollBehavior;
      }
      if (lockedFeed) {
        lockedFeed.style.overflow = this.feedOverflow;
        lockedFeed.scrollTop = this.feedScrollTop;
        if (!this.feedWasInert) lockedFeed.removeAttribute("inert");
      }
      this.active = false;
      this.body = this.html = this.feed = null;
      window.scrollTo(0, y);
    }
  };
  // Rolls (60cm / 90cm) are sold by the metre — the variant is one metre of that
  // width, so cart quantity = metres. A4 is a single sample sheet (no length).
  var currentMat = null, activeKey = "", activeIsRoll = false, activePerPrice = 0, sheetMetres = 1;
  var LOW_STOCK_THRESHOLD_METRES = 5;

  function syncExpressCheckout() {
    window.VelvenExpressCheckout.sync(sheetEls, {
      variantId: activeVariant,
      available: activeAvailable && !sheetAddPending && !sheetAddInFlight(),
      isRoll: activeIsRoll,
      preorder: activeIsPreorder(),
      cart: sheetCart,
      quantity: sheetMetres
    });
  }

  // The size in the sheet is a preorder when the one stock-state rule marked it
  // so (snippets/vmcm-size-json). An A4 sample never is.
  function activeIsPreorder() {
    var size = currentMat && currentMat.sizes ? currentMat.sizes[activeKey] : null;
    return !!(activeIsRoll && size && size.preorder === true);
  }

  function stockLimitFor(size, isRoll) {
    if (!isRoll || !size || size.inventoryPolicy === "continue") return null;
    var stock = parseInt(size.stock, 10);
    return stock > 0 ? stock : null;
  }

  function activeStockLimit() {
    var size = currentMat && currentMat.sizes ? currentMat.sizes[activeKey] : null;
    return stockLimitFor(size, activeIsRoll);
  }

  function stockMessageFor(stockLimit) {
    if (!stockLimit || (sheet && sheet.hasAttribute("data-pdp-declutter"))) return "In stock";
    var amount = stockLimit + (stockLimit === 1 ? " metre" : " metres");
    return stockLimit < LOW_STOCK_THRESHOLD_METRES ? "Low stock — " + amount + " left" : amount + " in stock";
  }

  function stockStateFor(isAvailable, stockLimit) {
    if (!isAvailable) return "out";
    return stockLimit && stockLimit < LOW_STOCK_THRESHOLD_METRES ? "low" : "in";
  }

  function selectSheetSize(input) {
    prepareAnotherSelection();
    activeVariant = parseInt(input.value, 10) || 0;
    setShipNote(input.dataset.sizeKey);
    setStockNote(input.dataset.sizeKey);
    activeKey = input.dataset.sizeKey || "";
    var sz = currentMat && currentMat.sizes ? currentMat.sizes[activeKey] : null;
    activeAvailable = !!(sz && activeVariant && sz.available !== false);
    if (sheetEls.cta) sheetEls.cta.disabled = !activeVariant || !activeAvailable;
    activeIsRoll = activeKey !== "a4";
    activePerPrice = sz ? sz.price : 0;
    sheetMetres = 1;
    updateMetresUI();
  }

  // Switching sizes must not resize the sheet: never shrink while open (CSS caps the reserve at the sheet max-height).
  function holdSheetHeight(height) {
    var inner = sheet && sheet.querySelector(".vmcm-sheet__inner");
    if (!inner) return;
    var reserved = parseFloat(inner.style.getPropertyValue("--vmcm-sheet-reserve")) || 0;
    inner.style.setProperty("--vmcm-sheet-reserve", Math.max(height, inner.offsetHeight || 0, reserved) + "px");
  }

  // Reserve the tallest selectable size state; measured in one task, so nothing paints between states.
  function reserveSheetHeight(fresh) {
    var inner = sheet && sheet.querySelector(".vmcm-sheet__inner");
    if (!inner || !sheetEls.sizes || sheetAddComplete || sheetAddInFlight() || sheet.classList.contains("is-added")) return;
    if (fresh) inner.style.removeProperty("--vmcm-sheet-reserve");
    var current = sheetEls.sizes.querySelector('input[name="vmcm-size"]:checked');
    if (!current) return;
    var metres = sheetMetres, tallest = 0;
    sheetEls.sizes.querySelectorAll('input[name="vmcm-size"]').forEach(function (input) {
      if (input.disabled) return;
      selectSheetSize(input);
      tallest = Math.max(tallest, inner.offsetHeight || 0);
    });
    selectSheetSize(current);
    sheetMetres = metres;
    updateMetresUI();
    holdSheetHeight(tallest);
  }
  // Express checkout buttons and the shipping bar render after open; re-reserve once they settle.
  if (sheet && window.ResizeObserver) {
    var sheetLateContent = new ResizeObserver(function () { if (sheet.open) reserveSheetHeight(false); });
    [sheetEls.expressForm, sheetEls.shipbar].forEach(function (el) { if (el) sheetLateContent.observe(el); });
  }

  function updateMetresUI() {
    if (!sheetEls || !sheetEls.metres) return;
    var stockLimit = activeStockLimit();
    if (stockLimit && sheetMetres > stockLimit) sheetMetres = stockLimit;
    sheetEls.metres.hidden = !activeIsRoll;
    if (sheetEls.cutting) sheetEls.cutting.hidden = !activeIsRoll;
    if (sheetEls.metresVal) sheetEls.metresVal.textContent = sheetMetres + (sheetMetres === 1 ? " metre" : " metres");
    if (sheetEls.metresTotal) sheetEls.metresTotal.textContent = (activeIsRoll && activePerPrice) ? money(activePerPrice * sheetMetres) : "";
    if (sheetEls.metresDec) sheetEls.metresDec.disabled = !activeIsRoll || sheetMetres <= 1;
    if (sheetEls.metresInc) sheetEls.metresInc.disabled = !activeIsRoll || !!(stockLimit && sheetMetres >= stockLimit);
    if (sheetEls.cta && !sheetAddComplete) sheetEls.cta.textContent = selectionCtaLabel();
    syncExpressCheckout();
    renderSheetShipProgress();
  }

  function selectionCtaLabel() {
    if (!activeVariant) return CTA_LABEL;
    if (!activeIsRoll) return "Add to cart";
    var widths = { r60: "60cm", r90: "90cm", r120: "120cm" };
    var width = widths[activeKey] || "roll";
    if (activeIsPreorder()) return "Preorder " + width + " x " + sheetMetres + "m roll";
    return "Add " + width + " x " + sheetMetres + "m roll to cart";
  }

  function prepareAnotherSelection() {
    if (sheetAddInFlight()) return;
    if (sheet) sheet.classList.remove('is-added');
    sheetAddComplete = false;
    if (sheetEls.done) sheetEls.done.hidden = true;
    if (sheetEls.error) sheetEls.error.textContent = "";
    if (sheetEls.cta) {
      sheetEls.cta.hidden = false;
      sheetEls.cta.disabled = !activeVariant || !activeAvailable;
      sheetEls.cta.textContent = selectionCtaLabel();
    }
  }

  // Per size shipping line in the sheet (A4 free, rolls use the standard roll
  // profile); text lives in data-ship-<key> on the sheet element.
  function setShipNote(key) {
    if (!sheetEls || !sheetEls.ship) return;
    if (sheetEls.sampleCredit) sheetEls.sampleCredit.hidden = key !== "a4";
    // The free-shipping bar is a roll rule; a sample already ships free.
    if (sheetEls.shipbar) sheetEls.shipbar.hidden = key === "a4";
    var note = key ? (sheetEls.ship.getAttribute("data-ship-" + key) || "") : "";
    if (key === "a4" && note) {
      var periodIndex = note.indexOf(".");
      var firstSentenceEnd = periodIndex === -1 ? note.length : periodIndex + 1;
      var strong = document.createElement("strong");
      strong.textContent = note.slice(0, firstSentenceEnd);
      sheetEls.ship.textContent = "";
      sheetEls.ship.appendChild(strong);
      sheetEls.ship.appendChild(document.createTextNode(note.slice(firstSentenceEnd)));
    } else {
      sheetEls.ship.textContent = note;
    }
    if (sheetEls.shipbar) sheetEls.shipbar.hidden = key === "a4";
  }

  function setStockNote(key) {
    if (!sheetEls || !sheetEls.stock) return;
    var s = currentMat && currentMat.sizes ? currentMat.sizes[key] : null;
    var hasVariant = !!(s && s.id);
    var isAvailable = hasVariant && s.available !== false;
    var stockLimit = stockLimitFor(s, key && key !== "a4");
    var isPre = !!(hasVariant && key !== "a4" && s.preorder === true);
    var copy = window.VelvenPreorder ? window.VelvenPreorder.copy() : { note: "Ships in about 8 weeks" };
    sheetEls.stock.textContent = isPre ? "Preorder · " + copy.note : (hasVariant ? (isAvailable ? stockMessageFor(stockLimit) : "Out of stock") : "Unavailable");
    var needsArrival = hasVariant && key !== 'a4' && (isPre || !isAvailable);
    var arrival = window.VelvenPreorderArrival && window.VelvenPreorderArrival.render(sheetEls.stock, needsArrival ? currentMat.handle : '', isPre ? 'Preorder · ' : 'Out of stock · ');
    sheetEls.stock.dataset.stockState = isPre ? "preorder" : stockStateFor(isAvailable, stockLimit);
    if (sheetEls.preorder) {
      sheetEls.preorder.hidden = !isPre && !arrival;
      sheetEls.preorder.textContent = arrival ? 'Arrival is an estimate, not a delivery date.' : (isPre ? ((window.VELVEN_PREORDER && window.VELVEN_PREORDER.detail) || "") : "");
    }
  }

  function firstSize(m) {
    var order = ["a4", "r60", "r90", "r120"];
    for (var i = 0; i < order.length; i++) {
      var s = m.sizes[order[i]];
      if (s && s.id && s.available !== false) return s;
    }
    // fall back to any with an id even if unavailable flag missing
    for (var j = 0; j < order.length; j++) { if (m.sizes[order[j]] && m.sizes[order[j]].id) return m.sizes[order[j]]; }
    return null;
  }

  function displayFromSize(m) {
    if (!m || !m.sizes) return null;
    var r60 = m.sizes.r60;
    if (r60 && r60.id) return r60;
    return firstSize(m);
  }

  // Delegate: any element with data-handle opens the sheet
  feed.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-handle]");
    if (!trigger) return;
    if (trigger.hasAttribute("data-sample-swatch")) return;
    e.preventDefault();
    openSheet(trigger.getAttribute("data-handle"), trigger);
  });

  var SIZE_DEFS = [
    { key: "a4", name: "A4 sample", note: "Touch it first" },
    { key: "r60", name: "60cm", note: "Roll, by the metre" },
    { key: "r90", name: "90cm", note: "Roll, by the metre" },
    { key: "r120", name: "120cm", note: "Roll, by the metre" }
  ];

  function openSheet(handle, trigger) {
    if (sheetAddInFlight()) return;
    var m = byHandle[handle];
    if (!m || !sheet) return;
    lastTrigger = trigger || null;
    currentMat = m;
    sheet.classList.remove('is-added');

    if (sheetEls.title) sheetEls.title.textContent = m.name;
    if (sheetEls.finish) sheetEls.finish.textContent = m.finish || "Velven finish";
    if (sheetEls.chip) {
      sheetEls.chip.style.setProperty("--sheet-color", m.plane);
      sheetEls.chip.style.backgroundImage = m.image ? "url(" + m.image + ")" : "none";
    }
    if (sheetEls.link && m.url) {
      sheetEls.link.href = m.url;
      var onOwnPage = false;
      try { onOwnPage = new URL(m.url, window.location.origin).pathname === window.location.pathname; } catch (err) {}
      sheetEls.link.hidden = onOwnPage;
    }
    if (sheetEls.error) sheetEls.error.textContent = "";
    if (sheetEls.ship) sheetEls.ship.textContent = "";
    if (sheetEls.stock) { sheetEls.stock.textContent = ""; delete sheetEls.stock.dataset.stockState; }
    if (sheetEls.preorder) { sheetEls.preorder.hidden = true; sheetEls.preorder.textContent = ""; }
    if (sheetEls.restock) {
      // The A4 sample is out and this page carries the restock form: offer the alert.
      var a4 = m.sizes && m.sizes.a4;
      var canAlert = !!(a4 && a4.id && a4.available === false && document.querySelector("[data-restock-dialog]"));
      sheetEls.restock.hidden = !canAlert;
      sheetEls.restock.setAttribute("data-restock-handle", m.handle || "");
      sheetEls.restock.setAttribute("data-restock-finish", m.name || "");
    }
    if (sheetEls.done) sheetEls.done.hidden = true;
    if (sheetEls.cta) { sheetEls.cta.hidden = false; sheetEls.cta.textContent = CTA_LABEL; }
    sheetAddComplete = false;
    sheetCartLifetime++;
    sheetCart = null;
    renderSheetShipProgress();

    // build size radios
    var def = firstSize(m);
    // Incoming listing variants belong only to this finish's PDP, never related cards.
    // An explicit sample action still opens the sample rather than the linked roll.
    var sizeIntent = lastTrigger && lastTrigger.getAttribute ? lastTrigger.getAttribute("data-size") : "";
    var incomingVariant = null;
    if (sizeIntent !== "a4" && m.url) {
      try {
        if (new URL(m.url, window.location.origin).pathname === window.location.pathname) {
          incomingVariant = new URLSearchParams(window.location.search).get("variant");
        }
      } catch (err) {}
    }
    // Roll actions and invalid listing links fall back to the first purchasable width.
    if (sizeIntent === "roll" || incomingVariant !== null) {
      var rollOrder = ["r60", "r90", "r120"];
      for (var ri = 0; ri < rollOrder.length; ri++) {
        var rs = m.sizes[rollOrder[ri]];
        if (rs && rs.id && rs.available !== false) { def = rs; break; }
      }
    }
    if (incomingVariant !== null) {
      SIZE_DEFS.some(function (sd) {
        var incoming = m.sizes[sd.key];
        if (!incoming || !incoming.id || String(incoming.id) !== incomingVariant || incoming.available === false) return false;
        def = incoming;
        return true;
      });
    }
    activeVariant = def ? def.id : 0;
    activeAvailable = false;
    activeKey = "";
    activeIsRoll = false;
    activePerPrice = 0;
    if (sheetEls.sizes) {
      sheetEls.sizes.replaceChildren();
      SIZE_DEFS.forEach(function (sd) {
        var s = m.sizes[sd.key];
        var id = s && s.id ? s.id : 0;
        var avail = id && s.available !== false;

        var label = document.createElement("label");
        label.className = "vmcm-sheet__size";

        var input = document.createElement("input");
        input.type = "radio";
        input.name = "vmcm-size";
        input.value = String(id);
        input.dataset.sizeKey = sd.key;
        if (def && id === def.id) { input.checked = true; activeAvailable = !!avail; setShipNote(sd.key); setStockNote(sd.key); activeKey = sd.key; activeIsRoll = sd.key !== "a4"; activePerPrice = s ? s.price : 0; }
        if (!avail) input.disabled = true;

        var name = document.createElement("span");
        name.className = "vmcm-sheet__size-name";
        name.textContent = sd.name;

        var price = document.createElement("span");
        price.className = "vmcm-sheet__size-price";
        price.textContent = id ? (sd.key === "a4" ? money(s.price) : money(s.price) + " / m") : "—";

        label.append(input, name, price);
        sheetEls.sizes.appendChild(label);
      });
    }
    if (sheetEls.cta) sheetEls.cta.disabled = !activeVariant || !activeAvailable;
    sheetMetres = 1;
    updateMetresUI();
    readSheetCartProgress();

    sheetScrollLock.lock();
    if (typeof sheet.showModal === "function") sheet.showModal();
    else sheet.setAttribute("open", "");
    reserveSheetHeight(true);
  }

  function closeSheet() {
    sheetScrollLock.unlock();
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  function dismissSheet() {
    if (!sheet) return;
    if (typeof sheet.close === "function") {
      sheet.close();
    } else {
      sheet.removeAttribute("open");
      closeSheet();
    }
  }

  if (sheet) {
    sheet.addEventListener("close", closeSheet);
    sheet.addEventListener("change", function (e) {
      if (e.target.name === "vmcm-size") {
        if (sheetAddInFlight()) {
          sheetEls.sizes.querySelectorAll('input[name="vmcm-size"]').forEach(function (input) {
            input.checked = input.dataset.sizeKey === activeKey;
          });
          return;
        }
        holdSheetHeight(0);
        selectSheetSize(e.target);
      }
    });
    if (sheetEls.metresDec) sheetEls.metresDec.addEventListener("click", function () {
      if (sheetAddInFlight()) return;
      prepareAnotherSelection();
      sheetMetres = Math.max(1, sheetMetres - 1);
      updateMetresUI();
    });
    if (sheetEls.metresInc) sheetEls.metresInc.addEventListener("click", function () {
      if (sheetAddInFlight()) return;
      prepareAnotherSelection();
      var stockLimit = activeStockLimit();
      sheetMetres = stockLimit ? Math.min(stockLimit, sheetMetres + 1) : sheetMetres + 1;
      updateMetresUI();
    });
    // close on backdrop click
    sheet.addEventListener("click", function (e) {
      if (e.target === sheet) dismissSheet();
    });
    var closeBtn = sheet.querySelector("[data-sheet-close]");
    if (closeBtn) closeBtn.addEventListener("click", dismissSheet);
    var anotherBtn = sheet.querySelector("[data-sheet-another]");
    if (anotherBtn) anotherBtn.addEventListener("click", function () { if (!sheetAddInFlight()) dismissSheet(); });

    if (sheetEls.cta) sheetEls.cta.addEventListener("click", function () {
      if (sheetAddComplete) {
        prepareAnotherSelection();
        return;
      }
      if (!activeVariant || !activeAvailable) return;
      addToCart(activeVariant, activeIsRoll ? sheetMetres : 1);
    });
  }

  function addToCart(variantId, qty) {
    if (sheetAddPending || sheetAddInFlight()) return;
    sheetCartLifetime++;
    var checkout = sheet && sheet.querySelector('[data-sheet-checkout]');
    if (checkout) checkout.setAttribute('href', CART);
    if (!window.VelvenCartEvents) sheetAddPending++;
    sheetEls.cta.setAttribute("aria-busy", "true");
    syncExpressCheckout();
    qty = qty || 1;
    var items = [{ id: variantId, quantity: qty }];
    var addedMessage = sheet && sheet.querySelector('[data-sheet-donemsg]');
    if (addedMessage) addedMessage.textContent = 'Added to your bag.';
    var sampleProgress = sheet && sheet.querySelector('[data-sample-cart-progress]');
    if (sampleProgress) { sampleProgress.hidden = true; sampleProgress.replaceChildren(); }
    sheetAddComplete = false;
    if (sheetEls.error) sheetEls.error.textContent = "";
    if (sheetEls.done) sheetEls.done.hidden = true;
    if (sheetEls.cta) { sheetEls.cta.disabled = true; sheetEls.cta.textContent = "Adding…"; }
    var sampleState = !activeIsRoll && window.VelvenSampleProgress;
    var beforeSamples = sampleState ? sampleState.beginAdd({
      variant_id: variantId, variant_title: 'A4 Sample', quantity: qty,
      product_title: currentMat.name, handle: currentMat.handle, image: currentMat.image
    }) : 0;
    if (sampleState) {
      if (addedMessage) addedMessage.textContent = 'Adding sample…';
      sheet.classList.add('is-added', 'is-sample-pending');
      sheetEls.done.hidden = false;
      sheetEls.cta.hidden = true;
    }
    var mutation = standardCartAdd(items, sheet || feed, "dialog", function () {
      return fetch(ADD, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error("add failed");
        return res.json();
      });
    });
    mutation.then(function () {
      if (!window.VelvenCartEvents) sheetAddPending--;
      sheetEls.cta.removeAttribute("aria-busy");
      sheetCartLifetime++;
      if (sampleState) {
        sampleState.render(sampleState.finishAdd(true), { added: true, before: beforeSamples, isRoll: false, confirmed: false });
      }
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      sheetCartTotal += selectedLineValue();
      sheetCart = null;
      syncExpressCheckout();
      sheetAddComplete = true;
      if (sheet) { sheet.classList.add('is-added'); sheet.classList.remove('is-sample-pending'); }
      // The confirmation replaces the button: View bag + Checkout at the same
      // height, with "Add another finish" as a text row beneath.
      if (sheetEls.cta) { sheetEls.cta.hidden = true; sheetEls.cta.disabled = false; sheetEls.cta.textContent = selectionCtaLabel(); }
      if (checkout) checkout.setAttribute('href', CART);
      if (sheetEls.done) sheetEls.done.hidden = false;
      var addedLifetime = sheetCartLifetime, addedIsRoll = activeIsRoll;
      if (window.VelvenSampleProgress) window.VelvenSampleProgress.read().then(function (cart) {
        if (addedLifetime !== sheetCartLifetime) return;
        window.VelvenSampleProgress.render(cart, { added: true, before: beforeSamples, isRoll: addedIsRoll });
      }).catch(function () {});
      renderSheetShipProgress();
      readSheetCartProgress();
    }).catch(function () {
      if (!window.VelvenCartEvents) sheetAddPending--;
      sheetEls.cta.removeAttribute("aria-busy");
      sheetCartLifetime++;
      if (sampleState) {
        sampleState.finishAdd(false);
        sampleState.read().then(function (cart) { sampleState.render(cart); }).catch(function () {});
        sheet.classList.remove('is-added', 'is-sample-pending');
        sheetEls.done.hidden = true;
        sheetEls.cta.hidden = false;
      }
      sheetCart = null;
      syncExpressCheckout();
      renderSheetShipProgress();
      readSheetCartProgress();
      if (sheetEls.error) sheetEls.error.textContent = "Something slipped. Try once more.";
      if (sheetEls.cta) { sheetEls.cta.disabled = false; sheetEls.cta.textContent = selectionCtaLabel(); }
    });
  }

  /* --------------------------------------------------------------------------
     Express add — single-variant one-tap buy (e.g. the Sample Box). Adds the
     variant, then hands off to the cart so the shopper can review before checkout.
     The ONLY cart write is the tap.
     ------------------------------------------------------------------------ */
  feed.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-express-add]");
    if (!btn) return;
    e.preventDefault();
    var vid = parseInt(btn.getAttribute("data-variant"), 10);
    if (!vid) return;
    var label = btn.querySelector("span") || btn;
    var orig = label.textContent;
    var errEl = document.querySelector("[data-express-error]");
    if (errEl) errEl.textContent = "";
    btn.disabled = true; label.textContent = "Adding…";
    var items = [{ id: vid, quantity: 1 }];
    standardCartAdd(items, btn, "product", function () {
      return fetch(ADD, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error("add failed");
        return res.json();
      });
    }).then(function () {
      window.location.href = CART;
    }).catch(function () {
      btn.disabled = false; label.textContent = orig;
      if (errEl) errEl.textContent = "Something slipped. Try once more.";
    });
  });

  /* --------------------------------------------------------------------------
     Sample Box + Inspiration pickers — the ONLY cart write is the explicit
     confirm tap. Pricing/activation: docs/launch/automatic-sample-boxes.md.
     ------------------------------------------------------------------------ */
  // The favourites page has its own sample picker (assets/vmcm-favourites.js) that
  // owns the same [data-sample-swatch] / [data-sample-confirm] hooks. Skip this one
  // there, or both handlers would add to the cart on confirm.
  var firstSwatch = document.querySelector("[data-sample-swatch]");
  if (firstSwatch && window.VelvenSamplePricing && !document.querySelector("[data-favourites-studio]")) {
    var SP = window.VelvenSamplePricing;
    var materialsByHandle = {};
    (window.VELVEN_MATERIALS || []).forEach(function (m) {
      if (m && m.handle) materialsByHandle[String(m.handle)] = m;
    });
    var countEls = Array.prototype.slice.call(document.querySelectorAll("[data-sample-count]"));
    var nudgeEls = Array.prototype.slice.call(document.querySelectorAll("[data-sample-nudge]"));
    var confirmBtns = Array.prototype.slice.call(document.querySelectorAll("[data-sample-confirm]"));
    var errEls = Array.prototype.slice.call(document.querySelectorAll("[data-sample-error]"));
    var picked = [];
    var inCart = [];
    var cartUnits = [];
    var pickerReady = false;
    var sampleSwatches = Array.prototype.slice.call(document.querySelectorAll("[data-sample-swatch]"));

    function sErr(t) { errEls.forEach(function (e) { e.textContent = t; }); }
    function sampleIsAvailable(handle) {
      var m = materialsByHandle[handle];
      return !!(m && m.sizes && m.sizes.a4 && m.sizes.a4.id && m.sizes.a4.available !== false);
    }
    var slotLists = Array.prototype.slice.call(document.querySelectorAll("[data-sample-slots]"));
    function sUnits() {
      return cartUnits.concat(picked.map(function (handle) {
        var m = materialsByHandle[handle];
        return { handle: handle, name: m.name };
      }));
    }
    function sRenderSlots() {
      var units = sUnits();
      // Show the partial group, or the last full six at an exact boundary.
      slotLists.forEach(function (list) {
        var slots = Array.prototype.slice.call(list.children);
        var remainder = units.length % slots.length;
        var recent = remainder ? units.slice(units.length - remainder) : units.slice(-slots.length);
        slots.forEach(function (slot, i) {
          var handle = recent[i] && recent[i].handle;
          var sw = handle ? sFindByHandle(handle) : null;
          var img = sw ? sw.querySelector(".vmcm-sample__chip img") : null;
          slot.classList.toggle("is-filled", !!recent[i]);
          slot.replaceChildren();
          if (img) { var copy = document.createElement("img"); copy.src = img.currentSrc || img.src; copy.alt = ""; slot.appendChild(copy); }
        });
        list.setAttribute("data-slot-count", String(units.length));
      });
      document.querySelectorAll("[data-sample-select]").forEach(function (tray) { tray.classList.toggle("has-picks", units.length > 0); });
    }
    function sUpdate() {
      var units = sUnits();
      countEls.forEach(function (c) { c.textContent = units.length; });
      sRenderSlots();
      document.querySelectorAll("[data-sample-picked-names]").forEach(function (list) {
        list.replaceChildren();
        units.forEach(function (unit) {
          var item = document.createElement("li");
          item.textContent = unit.name || 'A4 Sample';
          list.appendChild(item);
        });
      });
      nudgeEls.forEach(function (n) { n.textContent = SP.nudgeLine(units.length); });
      confirmBtns.forEach(function (b) {
        var newCount = picked.length;
        b.disabled = !pickerReady || !newCount;
        var lbl = b.querySelector("[data-sample-confirmlabel]");
        if (lbl) lbl.textContent = !pickerReady ? 'Checking your bag…' : newCount ? 'Add ' + newCount + (newCount === 1 ? ' sample' : ' samples') : 'Choose more finishes';
      });
    }
    function sSet(b, on) {
      var handle = b.getAttribute("data-handle") || "";
      if (!handle || inCart.indexOf(handle) >= 0) return false;
      var i = picked.indexOf(handle);
      if (on) {
        if (b.disabled || !sampleIsAvailable(handle)) {
          b.setAttribute("aria-pressed", "false");
          b.classList.remove("is-picked");
          return false;
        }
        if (i >= 0) return true;
        picked.push(handle);
        b.setAttribute("aria-pressed", "true");
        b.classList.add("is-picked");
        return true;
      }
      if (i >= 0) picked.splice(i, 1);
      b.setAttribute("aria-pressed", "false");
      b.classList.remove("is-picked");
      return true;
    }
    function sFindByHandle(handle) {
      for (var i = 0; i < sampleSwatches.length; i++) {
        if (sampleSwatches[i].getAttribute("data-handle") === handle) return sampleSwatches[i];
      }
      return null;
    }
    function sPrefillFlight() {
      if (!/[?&]flight=1(?:&|$)/.test(window.location.search)) return;
      var payload = null;
      try { payload = JSON.parse(window.localStorage.getItem("velven:sample-flight:v1") || "null"); } catch (e) {}
      var handles = payload && Array.isArray(payload.handles) ? payload.handles : [];
      for (var i = 0; i < handles.length; i++) {
        var sw = sFindByHandle(String(handles[i]));
        if (sw && !sw.disabled) sSet(sw, true);
      }
      if (picked.length) sErr("");
      sUpdate();
    }

    feed.addEventListener("click", function (e) {
      var b = e.target.closest("[data-sample-swatch]");
      if (!b) return;
      e.preventDefault();
      var handle = b.getAttribute("data-handle") || "";
      if (!pickerReady || b.disabled || inCart.indexOf(handle) >= 0 || !sampleIsAvailable(handle)) return;
      var i = picked.indexOf(handle);
      if (i >= 0) sSet(b, false); else sSet(b, true);
      sErr("");
      sUpdate();
    });

    if (window.VelvenSampleProgress) window.VelvenSampleProgress.read().then(function (cart) {
      window.VelvenSampleProgress.samples(cart).forEach(function (line) {
        var handle = Object.keys(materialsByHandle).find(function (h) {
          var m = materialsByHandle[h];
          return m.sizes && m.sizes.a4 && String(m.sizes.a4.id) === String(line.variant_id);
        });
        var m = materialsByHandle[handle];
        var name = (m && m.name) || line.product_title || 'A4 Sample';
        for (var i = 0; i < line.quantity; i++) cartUnits.push({ handle: handle, name: name });
        if (!handle) return;
        if (inCart.indexOf(handle) < 0) inCart.push(handle);
        sampleSwatches.forEach(function (sw) {
          if (sw.getAttribute('data-handle') !== handle) return;
          sw.setAttribute('aria-pressed', 'true');
          sw.classList.add('is-picked');
          sw.disabled = true;
          sw.setAttribute('aria-label', name + ' · already in your bag. Edit in cart.');
        });
      });
      pickerReady = true;
      sPrefillFlight(); sUpdate();
    }).catch(function () { sErr('Could not read your bag. Reload before choosing samples.'); });

    // "Pick your samples" is an in-page jump; when the picker is already in view the
    // jump moves nothing, so every tap also pulses the picker so it always answers.
    var pickNudgeTimer = 0;
    feed.addEventListener("click", function (e) {
      var cta = e.target.closest('a[href$="#vmcm-sample-inside"]');
      if (!cta) return;
      var tray = document.querySelector(".vmcm-sample__pick");
      var grid = document.querySelector(".vmcm-sample__grid");
      [tray, grid].forEach(function (el) { if (el) { el.classList.remove("is-called"); void el.offsetWidth; el.classList.add("is-called"); } });
      clearTimeout(pickNudgeTimer);
      pickNudgeTimer = setTimeout(function () {
        [tray, grid].forEach(function (el) { if (el) el.classList.remove("is-called"); });
      }, 1300);
    });

    confirmBtns.forEach(function (btn) {
      var lbl = btn.querySelector("[data-sample-confirmlabel]");
      btn.addEventListener("click", function () {
        if (!pickerReady || !picked.length) return;
        var vid = parseInt(btn.getAttribute("data-variant"), 10);
        if (!vid) return;
        var resolvedPicks = [];
        for (var i = 0; i < picked.length; i++) {
          var m = materialsByHandle[picked[i]];
          if (!sampleIsAvailable(picked[i])) {
            sErr("One of your picks is now out of stock. Remove it to continue.");
            return;
          }
          resolvedPicks.push({ name: m.name || picked[i], a4Id: m.sizes.a4.id, handle: picked[i] });
        }
        var items = SP.buildCartItems(resolvedPicks, vid);
        if (!items.length) return;
        confirmBtns.forEach(function (b) { b.disabled = true; });
        if (lbl) lbl.textContent = "Adding…";
        sErr("");
        standardCartAdd(items, btn, "dialog", function () {
          return fetch(ADD, {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ items: items })
          }).then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); });
        })
        .then(function () { window.location.href = CART + window.location.search; })
        .catch(function () {
          sUpdate();
          sErr("Something slipped. Try once more.");
        });
      });
    });

    sUpdate();
  }

  /* --------------------------------------------------------------------------
     Nav overlay — full-screen <dialog> menu, snap-safe scroll lock
     ------------------------------------------------------------------------ */
  var nav = document.querySelector("[data-nav]");
  var navOpenBtn = document.querySelector("[data-nav-open]");
  if (nav && navOpenBtn) {
    navOpenBtn.style.display = "inline-flex"; // reveal only when JS can drive it
    var navRestoreY = 0;
    navOpenBtn.addEventListener("click", function () {
      navRestoreY = feed.scrollTop;
      feed.style.overflow = "hidden";
      feed.setAttribute("inert", "");
      if (typeof nav.showModal === "function") nav.showModal(); else nav.setAttribute("open", "");
    });
    nav.addEventListener("close", function () {
      feed.style.overflow = "";
      feed.removeAttribute("inert");
      feed.scrollTop = navRestoreY;
      if (navOpenBtn.focus) navOpenBtn.focus();
    });
    nav.addEventListener("click", function (e) { if (e.target === nav) nav.close(); });
    var navCloseBtn = nav.querySelector("[data-nav-close]");
    if (navCloseBtn) navCloseBtn.addEventListener("click", function () { nav.close(); });
  }

  /* --------------------------------------------------------------------------
     The Velven difference — interactive film cross-section
     Hover (desktop) or tap-to-pin (touch) a band to flood it with its colour
     and reveal that technology. Copy is read from each zone's data-* attrs.
     ------------------------------------------------------------------------ */
  var diff = feed.querySelector("[data-vwfilm]");
  if (diff) {
    var zones = Array.prototype.slice.call(diff.querySelectorAll("[data-zone]"));
    var annoDefault = diff.querySelector("[data-anno-default]");
    var annoTech = diff.querySelector("[data-anno-tech]");
    var aNum = diff.querySelector("[data-anno-num]");
    var aLabel = diff.querySelector("[data-anno-label]");
    var aTitle = diff.querySelector("[data-anno-title]");
    var aDesc = diff.querySelector("[data-anno-desc]");
    var diffPinned = false;
    var diffCurrent = "";

    function diffSet(zone) {
      var key = zone ? zone.getAttribute("data-zone") : "";
      diffCurrent = key;
      diff.setAttribute("data-active", key);
      diff.classList.toggle("is-engaged", !!key);
      zones.forEach(function (z) { z.classList.toggle("is-active", z === zone); });
      if (key && zone) {
        if (aNum) aNum.textContent = zone.getAttribute("data-num") || "";
        if (aLabel) aLabel.textContent = zone.getAttribute("data-label") || "";
        if (aTitle) aTitle.textContent = zone.getAttribute("data-title") || "";
        if (aDesc) aDesc.textContent = zone.getAttribute("data-desc") || "";
        if (annoDefault) annoDefault.hidden = true;
        if (annoTech) annoTech.hidden = false;
      } else {
        if (annoDefault) annoDefault.hidden = false;
        if (annoTech) annoTech.hidden = true;
      }
    }

    zones.forEach(function (z) {
      z.addEventListener("mouseenter", function () { if (!diffPinned && !coarse) diffSet(z); });
      z.addEventListener("mouseleave", function () { if (!diffPinned && !coarse) diffSet(null); });
      z.addEventListener("focus", function () { if (!diffPinned) diffSet(z); });
      z.addEventListener("blur", function () { if (!diffPinned) diffSet(null); });
      z.addEventListener("click", function (e) {
        e.preventDefault();
        if (diffPinned && diffCurrent === z.getAttribute("data-zone")) {
          diffPinned = false; diffSet(null);
        } else {
          diffPinned = true; diffSet(z);
        }
      });
    });
    // a tap on the panel background releases the pin
    diff.addEventListener("click", function (e) {
      if (!e.target.closest("[data-zone]")) { diffPinned = false; diffSet(null); }
    });
  }

  /* --------------------------------------------------------------------------
     Moodboard — build the tiles in as the panel enters view. Once revealed it
     stays revealed (snap-safe). Reduced motion = instant.
     ------------------------------------------------------------------------ */
  var moodPanel = feed.querySelector("[data-mood]");
  if (moodPanel) {
    if (reduceMotion) {
      moodPanel.classList.add("is-in");
    } else {
      var moodIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.2) {
            moodPanel.classList.add("is-in");
            moodIO.disconnect();
          }
        });
      }, { root: feed, threshold: [0, 0.2, 0.5] });
      moodIO.observe(moodPanel);
    }
  }

  /* --------------------------------------------------------------------------
     Column step control — keyboard / desktop alternative to the pinch. A
     [data-cols-step="in"|"out"] button steps the active grid one level. "out" =
     more per row (zoom out), "in" = fewer (zoom in). Generic; no-op without one.
     ------------------------------------------------------------------------ */
  feed.addEventListener("click", function (e) {
    var step = e.target.closest("[data-cols-step]");
    if (!step) return;
    e.preventDefault();
    var g = pinchTarget() || pinchGrids[0];
    if (!g) return;
    stepGrid(g, step.getAttribute("data-cols-step") === "out" ? 1 : -1);
  });

  /* --------------------------------------------------------------------------
     Inspiration page — room filters, before/after compare, and the immersive
     NN / total index. All guarded by [data-inspiration]; no-op everywhere else.
     ------------------------------------------------------------------------ */
  if (feed.hasAttribute("data-inspiration")) {
    var inspWall = feed.querySelector(".vmcm-insp__wall");
    var inspItems = inspWall ? Array.prototype.slice.call(inspWall.querySelectorAll("[data-insp-item]")) : [];

    var inspNow = feed.querySelector("[data-insp-now]");
    var inspTot = feed.querySelector("[data-insp-total]");
    function inspVisible() { return inspItems.filter(function (t) { return !t.hidden; }); }
    function inspRecount() { if (inspTot) inspTot.textContent = inspVisible().length; }

    // (a) room filters — hide/show by data-category; quotes (no category) show under All
    var filterBar = feed.querySelector("[data-vmcm-filter]");
    if (filterBar) {
      var chips = Array.prototype.slice.call(filterBar.querySelectorAll("[data-filter]"));
      function inspApplyFilter(f, updateUrl) {
        var valid = chips.some(function (c) { return c.getAttribute("data-filter") === f; });
        if (!valid) f = "all";
        chips.forEach(function (c) {
          var on = c.getAttribute("data-filter") === f;
          c.classList.toggle("is-active", on);
          c.setAttribute("aria-pressed", on ? "true" : "false");
        });
        inspItems.forEach(function (t) {
          var cat = t.getAttribute("data-category") || "";
          t.hidden = (f !== "all") && (cat !== f);
        });
        inspRecount();
        feed.scrollTop = 0;
        if (updateUrl && history.replaceState) {
          var nextUrl = new URL(window.location.href);
          if (f === "all") nextUrl.searchParams.delete("filter");
          else nextUrl.searchParams.set("filter", f);
          nextUrl.hash = "";
          history.replaceState(null, "", nextUrl.pathname + nextUrl.search + nextUrl.hash);
        }
      }
      chips.forEach(function (chip) {
        chip.addEventListener("click", function () {
          inspApplyFilter(chip.getAttribute("data-filter"), true);
        });
      });
      var initialFilter = "";
      try { initialFilter = new URLSearchParams(window.location.search).get("filter") || ""; } catch (e) {}
      if (!initialFilter) initialFilter = (window.location.hash || "").replace("#", "");
      if (initialFilter) inspApplyFilter(initialFilter, false);
    }

    // (b) before/after — the AFTER is the resting view; a tap on the plate (or
    // Enter/Space on its button) wipes the before in, and again wipes it out.
    Array.prototype.slice.call(feed.querySelectorAll("[data-ba]")).forEach(function (fig) {
      var item = fig.closest(".vmcm-insp__ba") || fig;
      var showBeforeLabel = fig.getAttribute("aria-label") || "Show the before view";
      var showAfterLabel = showBeforeLabel.replace(" before ", " after ");
      var hintText = fig.querySelector("[data-ba-hint] span");
      function setBaState(before) {
        item.classList.toggle("is-before", before);
        fig.setAttribute("aria-pressed", before ? "true" : "false");
        fig.setAttribute("aria-label", before ? showAfterLabel : showBeforeLabel);
        if (hintText) hintText.textContent = before ? "Tap to see after" : "Tap to see before";
      }
      setBaState(false);
      fig.addEventListener("click", function () {
        item.classList.add("has-interacted");
        setBaState(!item.classList.contains("is-before"));
      });
    });

    // (c) customer reels — only the reel in view plays. This keeps the page
    // quiet and light when more customer projects are added later, and honours
    // the visitor's reduced-motion preference.
    var inspReels = Array.prototype.slice.call(feed.querySelectorAll(".vmcm-insp__reelvideo"));
    if (inspReels.length) {
      if (reduceMotion || !("IntersectionObserver" in window)) {
        inspReels.forEach(function (video) {
          video.removeAttribute("autoplay");
          video.pause();
        });
      } else {
        var reelIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            var active = entry.isIntersecting && entry.intersectionRatio >= 0.55 && !video.closest("[hidden]");
            video.setAttribute("data-vmcm-reel-active", active ? "true" : "false");
            if (active && !document.hidden) {
              var playAttempt = video.play();
              if (playAttempt && playAttempt.catch) playAttempt.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { root: feed, threshold: [0, 0.55] });
        inspReels.forEach(function (video) { reelIO.observe(video); });
        document.addEventListener("visibilitychange", function () {
          inspReels.forEach(function (video) {
            if (document.hidden) video.pause();
            else if (video.getAttribute("data-vmcm-reel-active") === "true") {
              var playAttempt = video.play();
              if (playAttempt && playAttempt.catch) playAttempt.catch(function () {});
            }
          });
        });
      }
    }

    // (d) immersive index — visible-aware, updates on scroll and on filter
    inspRecount();
    if (("IntersectionObserver" in window) && inspNow) {
      var inspIO = new IntersectionObserver(function (entries) {
        var best = null;
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (!e.isIntersecting) continue;
          if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
        }
        if (!best) return;
        var idx = inspVisible().indexOf(best.target);
        if (idx >= 0) inspNow.textContent = idx + 1;
      }, { root: feed, rootMargin: "-45% 0px -45% 0px", threshold: 0 });
      inspItems.forEach(function (t) { inspIO.observe(t); });
    }
  }

  /* --------------------------------------------------------------------------
     Inspiration immersive glide — the wall items are .vmcm-insp__item, NOT
     .vmcm-panel, so the magnetic engine above is SKIPPED here; the page rode on
     raw native CSS proximity snap, whose UA-timed settle fought every swipe and
     felt janky. Drive the SAME eased, slowed glide as the rest of the site: a
     deliberate swipe / flick / wheel / arrow eases exactly one item with native
     snap turned OFF for the duration, then resumes snap on the target (already a
     snap point, so no jump). Reduced motion, too-few-items and (any future) wall
     mode all fall back to native scrolling.
     ------------------------------------------------------------------------ */
  if (verticalMagnetics && feed.hasAttribute("data-inspiration")) {
    var INSP_DUR = 820, inspGlideRaf = 0, inspTargetIdx = -1;

    function inspSecs() {
      var wall = feed.querySelector(".vmcm-insp__wall.is-cols-1");
      if (!wall) return null;                       // gallery / wall mode -> native free scroll
      return Array.prototype.slice.call(wall.children).filter(function (el) {
        return !el.hidden && el.offsetParent !== null && el.offsetHeight > 0;
      });
    }
    function inspActiveIdx(secs) {
      var top = feed.scrollTop + Math.min(20, feed.clientHeight * 0.1), i;
      for (i = 0; i < secs.length; i++) { var pt = secs[i].offsetTop; if (top >= pt && top < pt + secs[i].offsetHeight) return i; }
      var best = 0, bd = Infinity;
      for (i = 0; i < secs.length; i++) { var d = Math.abs(secs[i].offsetTop - feed.scrollTop); if (d < bd) { bd = d; best = i; } }
      return best;
    }
    function inspGlide(secs, idx) {
      idx = Math.max(0, Math.min(secs.length - 1, idx));
      inspTargetIdx = idx;
      cancelAnimationFrame(inspGlideRaf);
      var from = feed.scrollTop, to = secs[idx].offsetTop, d = to - from, t0 = null;
      if (reduceMotion || Math.abs(d) < 1) { feed.scrollTop = to; inspTargetIdx = -1; return; }
      feed.style.scrollSnapType = "none";
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / INSP_DUR);
        feed.scrollTop = from + d * easeGlide(p);
        if (p < 1) inspGlideRaf = requestAnimationFrame(step);
        else { feed.scrollTop = to; feed.style.scrollSnapType = ""; inspTargetIdx = -1; }
      }
      inspGlideRaf = requestAnimationFrame(step);
    }
    function inspBase(secs) { return inspTargetIdx >= 0 ? inspTargetIdx : inspActiveIdx(secs); }

    /* Touch — a small deliberate vertical swipe / flick advances one item. */
    var iY = 0, iX = 0, iT = 0, iOn = false;
    feed.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1 || usingGesture) { iOn = false; return; }
      var secs = inspSecs();
      if (!secs || secs.length < 2) { iOn = false; return; }
      iOn = true; iY = e.touches[0].clientY; iX = e.touches[0].clientX; iT = Date.now();
    }, { passive: true });
    feed.addEventListener("touchend", function (e) {
      if (!iOn || usingGesture) { iOn = false; return; }
      iOn = false;
      var tt = e.changedTouches && e.changedTouches[0]; if (!tt) return;
      var dy = tt.clientY - iY, dx = tt.clientX - iX, dt = Date.now() - iT;
      if (Math.abs(dx) >= Math.abs(dy)) return;             // horizontal — ignore
      var vy = Math.abs(dy) / Math.max(dt, 1);
      if (Math.abs(dy) < 20 && vy < 0.3) return;            // too small to be deliberate
      var secs = inspSecs(); if (!secs || secs.length < 2) return;
      inspGlide(secs, inspBase(secs) + (dy < 0 ? 1 : -1));
    }, { passive: true });

    /* Wheel — this page is immersive on every device; intent-gated so a single
       notch never leaps, and a taller item scrolls internally to its edge first. */
    var iWAcc = 0, iWDir = 0, iWTimer = null, iWLock = false, iWLockT = null, IW_TH = 40;
    feed.addEventListener("wheel", function (e) {
      if (e.ctrlKey || e.metaKey) return;                   // ctrl/cmd + wheel reserved
      var secs = inspSecs(); if (!secs || secs.length < 2) return;
      if (iWLock) { e.preventDefault(); return; }
      var dir = e.deltaY > 0 ? 1 : (e.deltaY < 0 ? -1 : 0);
      if (!dir) return;
      var cur = secs[inspActiveIdx(secs)];
      var top = cur.offsetTop, bot = top + cur.offsetHeight, EDGE = 4;
      if (dir > 0 && (feed.scrollTop + feed.clientHeight) < bot - EDGE) { iWAcc = 0; iWDir = 0; return; }
      if (dir < 0 && feed.scrollTop > top + EDGE) { iWAcc = 0; iWDir = 0; return; }
      e.preventDefault();
      if (dir !== iWDir) { iWDir = dir; iWAcc = 0; }
      iWAcc += Math.abs(e.deltaY);
      clearTimeout(iWTimer);
      iWTimer = setTimeout(function () { iWAcc = 0; iWDir = 0; }, 170);
      if (iWAcc < IW_TH) return;
      iWAcc = 0; iWDir = 0;
      inspGlide(secs, inspBase(secs) + dir);
      iWLock = true; clearTimeout(iWLockT);
      iWLockT = setTimeout(function () { iWLock = false; }, INSP_DUR);
    }, { passive: false });

    /* Keyboard — arrows / page / home / end step the immersive wall. */
    document.addEventListener("keydown", function (e) {
      var secs = inspSecs(); if (!secs || secs.length < 2) return;
      var t = e.target;
      if (t && t.closest && t.closest("input, textarea, select, [contenteditable], dialog")) return;
      if (e.key === "ArrowDown" || e.key === "PageDown") { e.preventDefault(); inspGlide(secs, inspBase(secs) + 1); }
      else if (e.key === "ArrowUp" || e.key === "PageUp") { e.preventDefault(); inspGlide(secs, inspBase(secs) - 1); }
      else if (e.key === "Home") { e.preventDefault(); inspGlide(secs, 0); }
      else if (e.key === "End") { e.preventDefault(); inspGlide(secs, secs.length - 1); }
    });
  }

  /* --------------------------------------------------------------------------
     Cart count — read-only GET on load
     ------------------------------------------------------------------------ */
  function refreshCart() {
    fetch(CART.replace(/\/$/, "") + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = c.item_count;
          el.hidden = c.item_count === 0;
        });
      }).catch(function () {});
  }
  refreshCart();
  document.addEventListener("cart:refresh", refreshCart);
})();

/* ============================================================================
   VELVEN — MCM cart page line editor (standalone; runs only on the bag).
   Quantity (+ / - / typed) and remove edit the cart in place via cart/change.js
   with the Section Rendering API, so totals stay server true. Delegation is
   bound to [data-cart-page] (never replaced); only the inner [data-cart] is
   swapped. Edits while a request is in flight are queued (latest qty per line
   wins) and replayed; an over stock rejection reverts that line and explains in
   the inline alert; a hard failure reloads so the bag is never left stale. A
   polite live region (outside the swapped node) announces the new total to
   screen readers, and focus is restored to the control that was used. The ONLY
   cart write is an explicit tap.
   ========================================================================== */
(function () {
  "use strict";

  var scope = document.querySelector("[data-cart-page]");
  if (!scope) return;

  var routes = (window.theme && window.theme.routes) || {};
  var ROOT = routes.root_url || "/";
  // routes.cart_change_url is /cart/change (no .js); the AJAX + Section Rendering
  // endpoint needs the .js suffix, or it 302s to HTML and the swap never fires.
  var CHANGE = routes.cart_change_url || (ROOT.replace(/\/$/, "") + "/cart/change");
  if (!/\.js(\?|$)/.test(CHANGE)) CHANGE += ".js";
  var CART_PATH = routes.cart_url || (ROOT.replace(/\/$/, "") + "/cart");

  var busy = false;
  var pending = {};        // line key -> desired quantity (latest wins)
  var refocus = null;      // { key, role } restored into the fresh subtree after a swap

  function root() { return scope.querySelector("[data-cart]"); }
  function live() { return scope.querySelector("[data-cart-live]"); }
  function inputFor(key) {
    var lines = scope.querySelectorAll("[data-line-key]");
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].getAttribute("data-line-key") === key) return lines[i].querySelector("[data-qty-input]");
    }
    return null;
  }

  function configuredChangeFor(key, quantity) {
    var lines = scope.querySelectorAll("[data-line-key]");
    var line = null;
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].getAttribute("data-line-key") === key) { line = lines[i]; break; }
    }
    if (!line || !line.getAttribute("data-order-plan-id")) return null;
    var previous = parseInt(line.getAttribute("data-current-quantity"), 10) || 0;
    if (previous === quantity) return null;
    return {
      product_handle: line.getAttribute("data-product-handle") || "",
      variant_id: parseInt(line.getAttribute("data-variant-id"), 10) || 0,
      placement: "cart",
      config_id: line.getAttribute("data-order-plan-id") || "",
      roll_width_cm: parseInt(line.getAttribute("data-order-plan-width"), 10) || 0,
      recommended_metres: parseInt(line.getAttribute("data-order-plan-recommended"), 10) || 0,
      selected_metres: quantity,
      previous_metres: previous,
      orientation: line.getAttribute("data-order-plan-orientation") || "",
      back_coverage: line.getAttribute("data-order-plan-back") || "",
      front_joins: parseInt(line.getAttribute("data-order-plan-front-joins"), 10) || 0,
      back_joins: parseInt(line.getAttribute("data-order-plan-back-joins"), 10) || 0,
      allowance_included: true
    };
  }

  function trackConfiguredChange(quantity, data) {
    if (!data || !window.VelvenOrderPlan || typeof window.VelvenOrderPlan.track !== "function") return;
    window.VelvenOrderPlan.track(quantity === 0 ? "configured_item_removed" : "configured_quantity_changed", data);
  }

  function setBusy(on) {
    busy = on;
    var c = root();
    if (c) {
      c.classList.toggle("is-busy", on);
      c.setAttribute("aria-busy", on ? "true" : "false");
      c.querySelectorAll("[data-split-radio]").forEach(function (radio) { radio.disabled = on; });
    }
  }

  function announce(cart) {
    var el = live();
    if (!el || !cart) return;
    var n = cart.item_count;
    var total = "$" + (Math.round(cart.total_price) / 100).toFixed(2);
    el.textContent = "Bag updated. " + n + (n === 1 ? " item" : " items") + ", subtotal " + total + ".";
  }

  function restoreFocus() {
    if (!refocus) return;
    var ref = refocus; refocus = null;
    var esc = (window.CSS && CSS.escape) ? CSS.escape(ref.key) : ref.key;
    var line = scope.querySelector("[data-line-key=\"" + esc + "\"]");
    var target = line && line.querySelector("[" + ref.role + "]");
    if (target) { try { target.focus(); } catch (e) {} return; }
    var heading = scope.querySelector(".vmcm-cart__title");   // line gone (removed) -> anchor at the top
    if (heading) { heading.setAttribute("tabindex", "-1"); try { heading.focus(); } catch (e) {} }
  }

  function flush() {
    if (busy) return;
    var keys = Object.keys(pending);
    if (!keys.length) {
      if (scope.querySelector("[data-split-state]")) window.location.reload();
      return;
    }
    var key = keys[0];
    var quantity = pending[key];
    delete pending[key];
    send(key, quantity);
  }

  function send(key, quantity) {
    var changeTracking = configuredChangeFor(key, quantity);
    setBusy(true);
    var c = root();
    var sid = c ? c.getAttribute("data-section-id") : null;
    var payload = { id: key, quantity: quantity };
    if (sid) { payload.sections = sid; payload.sections_url = CART_PATH; }
    fetch(CHANGE, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      if (!res.ok) {
        // Over stock / rejected (e.g. 422): explain, revert the line, drop the edit.
        var inp = inputFor(key);
        if (inp) inp.value = inp.defaultValue;
        var errEl = c && c.querySelector("[data-cart-error]");
        if (errEl) errEl.textContent = (res.data && (res.data.description || res.data.message)) || "That quantity is not available.";
        setBusy(false);
        flush();
        return;
      }
      var cart = res.data;
      trackConfiguredChange(quantity, changeTracking);
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      if (scope.querySelector("[data-split-state]")) { setBusy(false); flush(); return; }
      var sections = cart && cart.sections;
      // Use the requested id if present, else the only key Shopify returned, so
      // the swap is agnostic to the exact section id format for JSON templates.
      var key2 = sections ? (sections[sid] != null ? sid : Object.keys(sections)[0]) : null;
      var html = key2 ? sections[key2] : null;
      var current = root();
      if (html && current) {
        var fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-cart]");
        if (fresh) {
          current.replaceWith(fresh);
          busy = false;
          announce(cart);
          restoreFocus();
          flush();
          return;
        }
      }
      window.location.reload();
    }).catch(function () {
      if (scope.querySelector("[data-split-state]")) { setBusy(false); flush(); return; }
      window.location.reload();
    });
  }

  function queue(key, quantity, role) {
    if (!key) return;
    pending[key] = quantity;
    if (role) refocus = { key: key, role: role };
    flush();
  }

  function lineKey(el) { var l = el.closest("[data-line-key]"); return l ? l.getAttribute("data-line-key") : null; }

  scope.addEventListener("click", function (e) {
    var down = e.target.closest("[data-qty-down]");
    var up = e.target.closest("[data-qty-up]");
    var rem = e.target.closest("[data-remove]");
    if (!down && !up && !rem) return;
    e.preventDefault();
    var line = e.target.closest("[data-line-key]");
    var key = line ? line.getAttribute("data-line-key") : null;
    if (!key) return;
    if (rem) { queue(key, 0, "data-remove"); return; }
    var input = line.querySelector("[data-qty-input]");
    var cur = input ? (parseInt(input.value, 10) || 0) : 0;
    var next = up ? cur + 1 : Math.max(0, cur - 1);
    if (input) input.value = next;     // optimistic; server truth re-renders
    queue(key, next, up ? "data-qty-up" : "data-qty-down");
  });

  scope.addEventListener("change", function (e) {
    var input = e.target.closest("[data-qty-input]");
    if (!input) return;
    var key = lineKey(input);
    if (!key) return;
    var raw = (input.value || "").trim();
    var n = parseInt(raw, 10);
    // Empty / letters / negative = no change; restore the displayed quantity.
    if (raw === "" || isNaN(n) || n < 0) { input.value = input.defaultValue; return; }
    queue(key, n, "data-qty-input");
  });

  // With JS on, Enter in the quantity field applies the edit rather than
  // submitting the form (which would jump straight to checkout).
  scope.addEventListener("keydown", function (e) {
    if (e.key !== "Enter") return;
    var input = e.target.closest("[data-qty-input]");
    if (!input) return;
    e.preventDefault();
    input.blur();
  });
})();
